import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/pdf.svg'
import _imports_3 from '@/assets/doc.svg'
import _imports_4 from '@/assets/docx.svg'
import _imports_5 from '@/assets/xls.svg'
import _imports_6 from '@/assets/xlsx.svg'
import _imports_7 from '@/assets/txt.svg'
import _imports_8 from '@/assets/png.svg'
import _imports_9 from '@/assets/jpg.svg'
import _imports_10 from '@/assets/jpeg.svg'
import _imports_11 from '@/assets/csv.svg'
import _imports_12 from '@/assets/zip.svg'
import _imports_13 from '@/assets/mp4.svg'
import _imports_14 from '@/assets/deleteIcon.svg'
import _imports_15 from '@/assets/sortBy.svg'
import _imports_16 from '@/assets/arrowRight.svg'
import _imports_17 from '@/assets/cancel.svg'
import _imports_18 from '@/assets/fileUploadIcon.svg'
import _imports_19 from '@/assets/Browse.svg'
import _imports_20 from '@/assets/warning.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "row w-full flex-shrink-0 flex mt-2"
}
const _hoisted_3 = { class: "w-7/12" }
const _hoisted_4 = { class: "w-full minheight" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 pb-3 px-5 pt-5 border-lightgrey flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_9 = {
  key: 1,
  class: "h-full min-h-0"
}
const _hoisted_10 = { class: "descriptionToggle overflow-y-auto" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "w-6/12" }
const _hoisted_14 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_15 = { class: "w-6/12" }
const _hoisted_16 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_17 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "w-6/12" }
const _hoisted_25 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_26 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_27 = { class: "w-6/12" }
const _hoisted_28 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_29 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_33 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_34 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_35 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_36 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_37 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_38 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_39 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_41 = { class: "border-b border-lightgrey flex flex-row" }
const _hoisted_42 = { class: "text-xs py-0.5 bg-white font-bold h-auto flex items-center my-1.5 header" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "flex flex-row w-50 mt-2 mb-2" }
const _hoisted_45 = { class: "w-50 border-t border-r border-b p-2 header border-lightgrey rounded-r-sm" }
const _hoisted_46 = { class: "pl-3 flex items-center flex-wrap" }
const _hoisted_47 = {
  key: 0,
  class: "mt-1.5 text-xs"
}
const _hoisted_48 = {
  key: 1,
  class: "mt-1.5 text-xs"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "flex flex-row w-full pt-2" }
const _hoisted_51 = { class: "w-30 border-t border-r border-b p-2 header border-lightgrey" }
const _hoisted_52 = { class: "w-27 border-t border-r border-b p-2 header border-lightgrey w-23 rounded-r-sm" }
const _hoisted_53 = { class: "pl-20" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_56 = { class: "row flex flex-row w-full" }
const _hoisted_57 = { class: "w-6/12" }
const _hoisted_58 = { class: "w-6/12 leftspacing" }
const _hoisted_59 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_60 = { class: "row flex flex-row w-full" }
const _hoisted_61 = { class: "w-6/12" }
const _hoisted_62 = { class: "w-6/12 leftspacing" }
const _hoisted_63 = { class: "formcontainer upperspacing" }
const _hoisted_64 = { class: "row flex flex-row w-full" }
const _hoisted_65 = { class: "w-3/6" }
const _hoisted_66 = { class: "w-3/6 leftspacing" }
const _hoisted_67 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_68 = { class: "row flex flex-row w-full" }
const _hoisted_69 = { class: "w-6/12" }
const _hoisted_70 = { class: "w-6/12 leftspacing" }
const _hoisted_71 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_72 = { class: "row flex flex-row w-full" }
const _hoisted_73 = { class: "w-6/12" }
const _hoisted_74 = { class: "w-6/12 leftspacing" }
const _hoisted_75 = { class: "formcontainer upperspacing" }
const _hoisted_76 = { class: "row flex flex-row w-full" }
const _hoisted_77 = { class: "w-3/6" }
const _hoisted_78 = { class: "w-3/6 leftspacing" }
const _hoisted_79 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_80 = { class: "flex mb-1" }
const _hoisted_81 = { class: "w-6/12" }
const _hoisted_82 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_83 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_84 = { class: "w-6/12" }
const _hoisted_85 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_86 = { class: "flex mb-1" }
const _hoisted_87 = { class: "w-6/12" }
const _hoisted_88 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_89 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_90 = { class: "w-6/12" }
const _hoisted_91 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_92 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_93 = { class: "flex mb-1" }
const _hoisted_94 = { class: "w-6/12" }
const _hoisted_95 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_96 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_97 = { class: "w-6/12" }
const _hoisted_98 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_99 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_100 = { class: "w-full" }
const _hoisted_101 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_102 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_103 = { class: "w-full" }
const _hoisted_104 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_105 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_106 = { class: "w-full" }
const _hoisted_107 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_108 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_109 = { class: "w-full" }
const _hoisted_110 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_111 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_112 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_113 = { class: "row flex flex-row w-full" }
const _hoisted_114 = { class: "w-6/12" }
const _hoisted_115 = { class: "w-6/12 leftspacing" }
const _hoisted_116 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_117 = { class: "row flex flex-row w-full" }
const _hoisted_118 = { class: "w-6/12" }
const _hoisted_119 = { class: "w-6/12 leftspacing" }
const _hoisted_120 = { class: "formcontainer upperspacing" }
const _hoisted_121 = { class: "row flex flex-row w-full" }
const _hoisted_122 = { class: "w-3/6" }
const _hoisted_123 = { class: "w-3/6 leftspacing" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_126 = { class: "row flex flex-row w-full" }
const _hoisted_127 = { class: "w-6/12" }
const _hoisted_128 = { class: "w-6/12 leftspacing" }
const _hoisted_129 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_130 = { class: "row flex flex-row w-full" }
const _hoisted_131 = { class: "w-6/12" }
const _hoisted_132 = { class: "w-6/12 leftspacing" }
const _hoisted_133 = { class: "formcontainer upperspacing" }
const _hoisted_134 = { class: "row flex flex-row w-full" }
const _hoisted_135 = { class: "w-3/6" }
const _hoisted_136 = { class: "w-3/6 leftspacing" }
const _hoisted_137 = { key: 2 }
const _hoisted_138 = { key: 3 }
const _hoisted_139 = { class: "flex justify-between border-b border-lightgrey mt-2" }
const _hoisted_140 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_141 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_142 = { key: 4 }
const _hoisted_143 = { class: "evidence-tab-content" }
const _hoisted_144 = { class: "evidence-files-block" }
const _hoisted_145 = { class: "border-b border-lightgrey" }
const _hoisted_146 = { class: "flex justify-between mt-2" }
const _hoisted_147 = { class: "flex gap-2" }
const _hoisted_148 = { class: "evidence-files-section" }
const _hoisted_149 = {
  key: 0,
  class: "flex mt-5 gap-4 flex-wrap"
}
const _hoisted_150 = { class: "pdf w-full rounded-sm" }
const _hoisted_151 = ["onClick"]
const _hoisted_152 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_153 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_154 = {
  key: 2,
  src: _imports_4,
  alt: ""
}
const _hoisted_155 = {
  key: 3,
  src: _imports_5,
  alt: ""
}
const _hoisted_156 = {
  key: 4,
  src: _imports_6,
  alt: ""
}
const _hoisted_157 = {
  key: 5,
  src: _imports_2,
  alt: ""
}
const _hoisted_158 = {
  key: 6,
  src: _imports_7,
  alt: ""
}
const _hoisted_159 = {
  key: 7,
  src: _imports_8,
  alt: ""
}
const _hoisted_160 = {
  key: 8,
  src: _imports_9,
  alt: ""
}
const _hoisted_161 = {
  key: 9,
  src: _imports_10,
  alt: ""
}
const _hoisted_162 = {
  key: 10,
  src: _imports_11,
  alt: ""
}
const _hoisted_163 = {
  key: 11,
  src: _imports_12,
  alt: ""
}
const _hoisted_164 = {
  key: 12,
  src: _imports_13,
  alt: ""
}
const _hoisted_165 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_166 = { class: "ml-2 pb-1" }
const _hoisted_167 = ["title"]
const _hoisted_168 = { class: "flex justify-between w-full" }
const _hoisted_169 = { class: "ml-2 fontSize10PX" }
const _hoisted_170 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_171 = ["onClick"]
const _hoisted_172 = {
  key: 1,
  class: "text-xs text-placeholdergray mt-3"
}
const _hoisted_173 = { class: "evidence-links-section" }
const _hoisted_174 = { class: "border-b border-lightgrey flex justify-between mt-6" }
const _hoisted_175 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_176 = { class: "evidence-links-scroll" }
const _hoisted_177 = { class: "evidence-links-header" }
const _hoisted_178 = { class: "flex items-center" }
const _hoisted_179 = { class: "flex items-center" }
const _hoisted_180 = { class: "flex items-center" }
const _hoisted_181 = { class: "flex items-center" }
const _hoisted_182 = { class: "evidence-links-body" }
const _hoisted_183 = { key: 0 }
const _hoisted_184 = ["title"]
const _hoisted_185 = { class: "table-ellipsis" }
const _hoisted_186 = ["title"]
const _hoisted_187 = { class: "table-ellipsis" }
const _hoisted_188 = { class: "table-ellipsis" }
const _hoisted_189 = ["onClick", "title"]
const _hoisted_190 = { class: "evidence-links-col-action" }
const _hoisted_191 = ["onClick"]
const _hoisted_192 = { key: 1 }
const _hoisted_193 = { key: 5 }
const _hoisted_194 = { class: "border-b border-lightgrey flex justify-between mt-2" }
const _hoisted_195 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_196 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_197 = { class: "comment-box w-full" }
const _hoisted_198 = { class: "my-5" }
const _hoisted_199 = {
  key: 0,
  class: "comments"
}
const _hoisted_200 = {
  key: 0,
  class: "initials"
}
const _hoisted_201 = {
  key: 1,
  class: "initials"
}
const _hoisted_202 = { class: "w-1/5" }
const _hoisted_203 = { class: "header" }
const _hoisted_204 = { class: "fontSize10PX" }
const _hoisted_205 = { class: "w-4/5 text-xs" }
const _hoisted_206 = { key: 6 }
const _hoisted_207 = { class: "border-b border-lightgrey" }
const _hoisted_208 = { class: "flex justify-between mt-2" }
const _hoisted_209 = {
  key: 0,
  class: ""
}
const _hoisted_210 = ["onClick"]
const _hoisted_211 = ["onClick"]
const _hoisted_212 = { class: "flex flex-row" }
const _hoisted_213 = { class: "border header border-lightgrey w-77 p-2 rounded-tr-md text-xs" }
const _hoisted_214 = { class: "flex flex-row" }
const _hoisted_215 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_216 = { class: "flex flex-row" }
const _hoisted_217 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_218 = { class: "flex flex-row" }
const _hoisted_219 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center" }
const _hoisted_220 = ["title"]
const _hoisted_221 = { key: 1 }
const _hoisted_222 = { class: "flex flex-row" }
const _hoisted_223 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_224 = { class: "flex flex-row" }
const _hoisted_225 = { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }
const _hoisted_226 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md text-xs" }
const _hoisted_227 = {
  key: 7,
  class: "result-field-grid"
}
const _hoisted_228 = { class: "border-b border-lightgrey" }
const _hoisted_229 = { class: "flex justify-between mt-2" }
const _hoisted_230 = { key: 0 }
const _hoisted_231 = ["onClick"]
const _hoisted_232 = { class: "flex flex-row mt-5" }
const _hoisted_233 = { class: "border-l border-t border-b border-lightgrey text-xs flex items-center w-27 p-2 header" }
const _hoisted_234 = { class: "border-l border-t border-b border-r border-lightgrey w-27 p-2 rounded-tr-md flex justify-center" }
const _hoisted_235 = { class: "flex flex-row" }
const _hoisted_236 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-sm flex items-center" }
const _hoisted_237 = { class: "flex flex-row" }
const _hoisted_238 = { class: "border-b border-l text-sm flex items-center border-lightgrey w-27 p-2" }
const _hoisted_239 = { class: "border-r border-b border-l border-lightgrey text-sm flex items-center w-27 p-2" }
const _hoisted_240 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_241 = { class: "border-l border-r border-b header border-lightgrey w-77 p-2 h-14" }
const _hoisted_242 = {
  key: 0,
  class: "text-sm w-full h-[2.5rem] flex items-center font-normal"
}
const _hoisted_243 = {
  key: 1,
  class: "ml-2 mr-2"
}
const _hoisted_244 = { class: "progress-container" }
const _hoisted_245 = { class: "progress-indicator-count" }
const _hoisted_246 = { class: "flex flex-row" }
const _hoisted_247 = { class: "border-b border-l border-lightgrey w-27 p-2 flex justify-center items-center" }
const _hoisted_248 = { class: "border-r border-b border-l border-lightgrey w-27 p-2 flex justify-center items-center" }
const _hoisted_249 = ["title"]
const _hoisted_250 = { class: "flex flex-row" }
const _hoisted_251 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-sm flex items-center rounded-br-md" }
const _hoisted_252 = { key: 1 }
const _hoisted_253 = { class: "flex flex-row mt-5" }
const _hoisted_254 = { class: "border-l border-t border-b border-lightgrey text-xs flex items-center w-27 p-2 header" }
const _hoisted_255 = { class: "flex flex-row" }
const _hoisted_256 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-sm flex items-center" }
const _hoisted_257 = {
  key: 0,
  class: "border-b mt-3 border-lightgrey"
}
const _hoisted_258 = { class: "flex justify-between mt-2" }
const _hoisted_259 = { key: 1 }
const _hoisted_260 = ["onClick"]
const _hoisted_261 = { class: "flex flex-row mt-5" }
const _hoisted_262 = { class: "border-r border-t border-b border-l border-lightgrey w-27 p-2" }
const _hoisted_263 = { class: "border-t border-b border-l border-r border-lightgrey w-27 p-2 rounded-tr-md flex items-center justify-center" }
const _hoisted_264 = {
  key: 0,
  class: "flex items-center justify-center rounded h-5 w-28 text-xs font-semibold text-lightgreen bg-veryLowColor border-solid border border-lightgreen"
}
const _hoisted_265 = {
  key: 1,
  class: "flex items-center justify-center rounded h-5 w-28 text-xs font-semibold text-darkred bg-veryHighColor border-solid border border-darkred"
}
const _hoisted_266 = {
  key: 2,
  class: "flex items-center justify-center rounded h-5 w-28 px-2.5 text-xs font-semibold text-gray bg-lightgrey border-solid border border-lightgrey"
}
const _hoisted_267 = { class: "flex flex-row" }
const _hoisted_268 = { class: "border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_269 = { class: "border-r border-b border-l border-lightgrey w-27 p-2 flex items-center justify-center" }
const _hoisted_270 = {
  key: 0,
  class: "text-center"
}
const _hoisted_271 = { class: "flex flex-row" }
const _hoisted_272 = { class: "border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_273 = { class: "border-r border-b border-l border-lightgrey w-27 p-2 text-center" }
const _hoisted_274 = { class: "flex flex-row" }
const _hoisted_275 = { class: "border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_276 = { class: "border-r border-b border-l border-lightgrey w-27 p-2 text-center" }
const _hoisted_277 = { class: "flex flex-row" }
const _hoisted_278 = { class: "border-l border-lightgrey w-27 p-2" }
const _hoisted_279 = { class: "border-r border-l border-lightgrey w-27 p-2 text-center" }
const _hoisted_280 = { class: "flex flex-row" }
const _hoisted_281 = { class: "border-r border-t border-b border-l border-lightgrey w-77 p-2 rounded-br-md" }
const _hoisted_282 = { key: 2 }
const _hoisted_283 = ["onClick"]
const _hoisted_284 = { class: "flex flex-row mt-5" }
const _hoisted_285 = { class: "border-b border-l border-t border-lightgrey flex items-center w-27 p-2" }
const _hoisted_286 = { class: "flex flex-row" }
const _hoisted_287 = { class: "border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_288 = { class: "flex flex-row" }
const _hoisted_289 = { class: "border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_290 = { class: "border-r border-b border-l border-lightgrey w-27 p-2 text-center" }
const _hoisted_291 = { class: "flex flex-row" }
const _hoisted_292 = { class: "border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_293 = { key: 3 }
const _hoisted_294 = ["onClick"]
const _hoisted_295 = { class: "flex flex-row mt-5" }
const _hoisted_296 = { class: "border-r border-t border-b border-l border-lightgrey w-27 p-2" }
const _hoisted_297 = { class: "flex flex-row" }
const _hoisted_298 = { class: "border-r border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_299 = { class: "flex flex-row" }
const _hoisted_300 = { class: "border-r border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_301 = { class: "border-r border-l border-b border-lightgrey w-27 p-2 text-center" }
const _hoisted_302 = { class: "flex flex-row" }
const _hoisted_303 = { class: "border-r border-l border-b border-lightgrey w-27 p-2" }
const _hoisted_304 = { key: 8 }
const _hoisted_305 = { class: "border-b border-lightgrey flex justify-between mt-2" }
const _hoisted_306 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_307 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_308 = { class: "flex" }
const _hoisted_309 = {
  key: 0,
  class: "initials cursor-pointer"
}
const _hoisted_310 = {
  key: 1,
  class: "initials cursor-pointer"
}
const _hoisted_311 = { class: "logContainer w-93" }
const _hoisted_312 = { class: "flex pt-1.5" }
const _hoisted_313 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_314 = {
  key: 1,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_315 = {
  key: 2,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_316 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_317 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_318 = {
  key: 5,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_319 = {
  key: 6,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_320 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_321 = {
  key: 0,
  class: "flex"
}
const _hoisted_322 = { class: "text-xs w-5/6 ml-2" }
const _hoisted_323 = {
  key: 1,
  class: "flex flex-wrap items-center"
}
const _hoisted_324 = { class: "mx-2 text-xs" }
const _hoisted_325 = { class: "mx-2 text-xs" }
const _hoisted_326 = ["title"]
const _hoisted_327 = ["title"]
const _hoisted_328 = {
  key: 2,
  class: "flex mt-2"
}
const _hoisted_329 = { class: "mx-2 text-xs" }
const _hoisted_330 = {
  key: 3,
  class: "flex"
}
const _hoisted_331 = { class: "mx-2 text-xs" }
const _hoisted_332 = { class: "mx-2 text-xs" }
const _hoisted_333 = {
  key: 4,
  class: "flex"
}
const _hoisted_334 = { class: "mx-2 text-xs" }
const _hoisted_335 = {
  key: 5,
  class: "flex"
}
const _hoisted_336 = { class: "mx-2 text-xs" }
const _hoisted_337 = {
  key: 6,
  class: "flex"
}
const _hoisted_338 = { class: "mx-2 text-xs" }
const _hoisted_339 = {
  key: 7,
  class: "flex mt-2"
}
const _hoisted_340 = { class: "mx-2 text-xs" }
const _hoisted_341 = {
  key: 8,
  class: "flex mt-2"
}
const _hoisted_342 = { class: "mx-2 text-xs" }
const _hoisted_343 = {
  key: 9,
  class: "flex mt-2"
}
const _hoisted_344 = { class: "mx-2 text-xs" }
const _hoisted_345 = {
  key: 0,
  class: "flex mt-2 flex-wrap items-start"
}
const _hoisted_346 = { class: "mx-2 text-xs min-w-0 break-words" }
const _hoisted_347 = {
  key: 1,
  class: "flex mt-2"
}
const _hoisted_348 = { class: "mx-2 text-xs" }
const _hoisted_349 = {
  key: 11,
  class: "flex mt-2"
}
const _hoisted_350 = { class: "mx-2 text-xs" }
const _hoisted_351 = { class: "mx-2 text-xs" }
const _hoisted_352 = { class: "mx-2 text-xs" }
const _hoisted_353 = { class: "font-semibold text-xs shrink-0 whitespace-nowrap" }
const _hoisted_354 = ["title"]
const _hoisted_355 = ["title"]
const _hoisted_356 = { class: "mx-2 text-xs min-w-0 break-words" }
const _hoisted_357 = { class: "text-xs min-w-0 break-words" }
const _hoisted_358 = {
  key: 12,
  class: "flex"
}
const _hoisted_359 = { class: "mx-2 text-xs" }
const _hoisted_360 = {
  key: 13,
  class: "flex"
}
const _hoisted_361 = { class: "mx-2 text-xs" }
const _hoisted_362 = {
  key: 14,
  class: "flex"
}
const _hoisted_363 = { class: "mx-2 text-xs" }
const _hoisted_364 = {
  key: 15,
  class: "flex mt-2"
}
const _hoisted_365 = { class: "mx-2 text-xs" }
const _hoisted_366 = {
  key: 16,
  class: "flex mt-2"
}
const _hoisted_367 = { class: "mx-2 text-xs" }
const _hoisted_368 = {
  key: 17,
  class: "flex"
}
const _hoisted_369 = { class: "mx-2 text-xs" }
const _hoisted_370 = {
  key: 18,
  class: "flex items-center"
}
const _hoisted_371 = { class: "flex ml-4" }
const _hoisted_372 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_373 = { class: "m-3" }
const _hoisted_374 = { key: 0 }
const _hoisted_375 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_376 = {
  key: 1,
  class: "pt-2 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_377 = {
  key: 0,
  class: "bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2 mb-3"
}
const _hoisted_378 = { key: 1 }
const _hoisted_379 = { class: "mt-3" }
const _hoisted_380 = { class: "mt-3" }
const _hoisted_381 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_382 = {
  key: 0,
  class: "mb-3 mt-4"
}
const _hoisted_383 = { class: "mt-3" }
const _hoisted_384 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_385 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_386 = { class: "mt-3" }
const _hoisted_387 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_388 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_389 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_390 = { key: 3 }
const _hoisted_391 = { key: 4 }
const _hoisted_392 = { key: 0 }
const _hoisted_393 = {
  key: 5,
  class: "mt-2 text-sm"
}
const _hoisted_394 = { class: "mt-3" }
const _hoisted_395 = { class: "mt-3" }
const _hoisted_396 = { key: 0 }
const _hoisted_397 = { key: 1 }
const _hoisted_398 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_399 = { class: "findings-popup flex flex-col h-full min-w-0 max-w-full" }
const _hoisted_400 = { class: "flex-1 min-w-0 overflow-x-hidden overflow-y-auto" }
const _hoisted_401 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_402 = { class: "formcontainer flex flex-col" }
const _hoisted_403 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_404 = { class: "row flex flex-row w-full min-w-0" }
const _hoisted_405 = { class: "w-1/2 pr-2 min-w-0" }
const _hoisted_406 = { class: "mt-2 text-sm inputboxstyling truncate" }
const _hoisted_407 = { class: "w-1/2 min-w-0" }
const _hoisted_408 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_409 = { key: 0 }
const _hoisted_410 = { class: "row flex flex-row w-full min-w-0 upperspacing" }
const _hoisted_411 = { class: "w-1/2 pr-2 min-w-0" }
const _hoisted_412 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_413 = { key: 0 }
const _hoisted_414 = {
  key: 0,
  class: "w-1/2 min-w-0"
}
const _hoisted_415 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_416 = { key: 0 }
const _hoisted_417 = {
  key: 1,
  class: "w-1/2 min-w-0"
}
const _hoisted_418 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_419 = { key: 0 }
const _hoisted_420 = {
  key: 2,
  class: "w-1/2 min-w-0"
}
const _hoisted_421 = ["value", "title"]
const _hoisted_422 = { class: "row flex flex-row w-full min-w-0 upperspacing" }
const _hoisted_423 = { class: "w-1/2 pr-2 min-w-0" }
const _hoisted_424 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_425 = { key: 0 }
const _hoisted_426 = { class: "w-full upperspacing" }
const _hoisted_427 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_428 = {
  key: 0,
  class: "error-text"
}
const _hoisted_429 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_430 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_431 = ["disabled"]
const _hoisted_432 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_433 = { class: "flex flex-col h-full" }
const _hoisted_434 = { class: "flex-1 overflow-auto" }
const _hoisted_435 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_436 = { class: "formcontainer flex flex-col" }
const _hoisted_437 = { class: "row flex flex-row w-full" }
const _hoisted_438 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_439 = { class: "w-1/2 pr-2" }
const _hoisted_440 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_441 = {
  key: 0,
  class: "error-text"
}
const _hoisted_442 = {
  key: 1,
  class: "error-text"
}
const _hoisted_443 = { class: "w-1/2 pr-2" }
const _hoisted_444 = ["disabled"]
const _hoisted_445 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_446 = {
  key: 0,
  class: "error-text"
}
const _hoisted_447 = { class: "row flex flex-row w-full" }
const _hoisted_448 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_449 = { class: "w-1/2 pr-2" }
const _hoisted_450 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_451 = {
  key: 0,
  class: "error-text"
}
const _hoisted_452 = { class: "w-1/2 pr-2" }
const _hoisted_453 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_454 = {
  key: 0,
  class: "error-text"
}
const _hoisted_455 = { class: "row flex flex-row w-full" }
const _hoisted_456 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_457 = { class: "w-1/2 pr-2" }
const _hoisted_458 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_459 = {
  key: 0,
  class: "error-text"
}
const _hoisted_460 = { class: "w-full upperspacing" }
const _hoisted_461 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_462 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_463 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_464 = {
  key: 0,
  class: "w-full upperspacing"
}
const _hoisted_465 = { class: "mt-2 flex flex-wrap gap-2" }
const _hoisted_466 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_467 = ["disabled"]
const _hoisted_468 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_469 = { class: "kpi-result-popup flex flex-col h-full min-w-0 max-w-full" }
const _hoisted_470 = { class: "flex-1 min-w-0 overflow-x-hidden overflow-y-auto" }
const _hoisted_471 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_472 = { class: "formcontainer flex flex-col min-w-0" }
const _hoisted_473 = { class: "row flex flex-row w-full min-w-0 upperspacing" }
const _hoisted_474 = { class: "row flex flex-row w-full min-w-0" }
const _hoisted_475 = { class: "w-full pr-2 min-w-0" }
const _hoisted_476 = {
  key: 0,
  class: "kpi-title-select-wrap"
}
const _hoisted_477 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_478 = {
  key: 0,
  class: "error-text"
}
const _hoisted_479 = { class: "row flex flex-row w-full" }
const _hoisted_480 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_481 = { class: "w-1/2 pr-2" }
const _hoisted_482 = { class: "w-1/2 pr-2" }
const _hoisted_483 = ["value"]
const _hoisted_484 = { class: "row flex flex-row w-full" }
const _hoisted_485 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_486 = { class: "w-1/2 pr-2" }
const _hoisted_487 = ["value"]
const _hoisted_488 = { class: "w-1/2 pr-2" }
const _hoisted_489 = { class: "controllabel" }
const _hoisted_490 = ["placeholder"]
const _hoisted_491 = { class: "row flex flex-row w-full" }
const _hoisted_492 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_493 = { class: "w-1/2 pr-2" }
const _hoisted_494 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_495 = {
  key: 0,
  class: "error-text"
}
const _hoisted_496 = {
  key: 1,
  class: "error-text"
}
const _hoisted_497 = { class: "w-1/2 pr-2" }
const _hoisted_498 = ["disabled"]
const _hoisted_499 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_500 = {
  key: 0,
  class: "error-text"
}
const _hoisted_501 = { class: "row flex flex-row w-full" }
const _hoisted_502 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_503 = { class: "w-1/2 pr-2" }
const _hoisted_504 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_505 = {
  key: 0,
  class: "error-text"
}
const _hoisted_506 = { class: "w-full upperspacing" }
const _hoisted_507 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_508 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_509 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_510 = {
  key: 0,
  class: "w-full upperspacing"
}
const _hoisted_511 = { class: "mt-2 flex flex-wrap gap-2" }
const _hoisted_512 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_513 = ["disabled"]
const _hoisted_514 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_515 = { class: "flex flex-col h-full" }
const _hoisted_516 = { class: "flex-1 overflow-auto" }
const _hoisted_517 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_518 = { class: "formcontainer flex flex-col" }
const _hoisted_519 = { class: "row flex flex-col mt-2" }
const _hoisted_520 = { class: "controllabel" }
const _hoisted_521 = ["placeholder"]
const _hoisted_522 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_523 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_524 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_525 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_526 = {
  key: 0,
  class: "text-sm font-semibold text-darkblue mb-4"
}
const _hoisted_527 = {
  key: 1,
  class: "text-sm font-semibold text-primary mb-4"
}
const _hoisted_528 = { class: "flex items-center justify-center gap-2" }
const _hoisted_529 = ["disabled"]
const _hoisted_530 = { class: "min-h-[22px] text-red-500" }
const _hoisted_531 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_532 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_533 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_534 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_535 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_536 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_537 = { class: "pt-3 w-1/2" }
const _hoisted_538 = ["max"]
const _hoisted_539 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_540 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_541 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_542 = ["disabled"]
const _hoisted_543 = {
  key: 0,
  class: "fixed inset-0 z-[12000] flex items-center justify-center bg-black/50"
}
const _hoisted_544 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-5" }
const _hoisted_545 = { class: "flex items-center justify-end pt-4 mt-2 border-t border-lightgrey gap-2" }
const _hoisted_546 = {
  key: 0,
  class: "fixed inset-0 z-[12000] flex items-center justify-center bg-black/50"
}
const _hoisted_547 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-5" }
const _hoisted_548 = { class: "text-sm text-gray-600 mt-2" }
const _hoisted_549 = { class: "flex items-center justify-end pt-4 mt-2 border-t border-lightgrey gap-2" }
const _hoisted_550 = {
  key: 6,
  class: "evidence-delete-confirm"
}
const _hoisted_551 = { class: "evidence-delete-dialog" }
const _hoisted_552 = { class: "evidence-delete-dialog-actions" }
const _hoisted_553 = {
  key: 7,
  class: "link-existing-confirm"
}
const _hoisted_554 = { class: "link-existing-dialog" }
const _hoisted_555 = { class: "link-existing-tables" }
const _hoisted_556 = { class: "link-existing-section-row" }
const _hoisted_557 = { class: "link-existing-section" }
const _hoisted_558 = { class: "link-existing-table" }
const _hoisted_559 = { class: "flex table-header-label-wrap" }
const _hoisted_560 = { class: "flex table-header-label-wrap" }
const _hoisted_561 = { class: "flex table-header-label-wrap" }
const _hoisted_562 = { class: "flex table-header-label-wrap" }
const _hoisted_563 = {
  key: 0,
  class: "link-existing-filter-row"
}
const _hoisted_564 = { key: 0 }
const _hoisted_565 = { class: "link-existing-col-check" }
const _hoisted_566 = ["checked", "onChange"]
const _hoisted_567 = ["title"]
const _hoisted_568 = { key: 1 }
const _hoisted_569 = { class: "link-existing-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", {
              class: _normalizeClass(["title", _ctx.titleLength > 40 ? 'table-ellipsis' : ''])
            }, _toDisplayString(_ctx.presentTaskObject.appId == 10003? (_ctx.presentTaskObject.risk||'N/A') : (_ctx.presentTaskObject.controlTitle||'N/A')), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Tabs, {
              value: _ctx.selectedTabIndex,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
              scrollable: "",
              class: "w-80 pr-5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_TabList, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                        return (_openBlock(), _createBlock(_component_Tab, {
                          key: tab.id,
                          value: tab.id,
                          onClick: ($event: any) => (_ctx.toggleTabs(tab))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                      return (_openBlock(), _createBlock(_component_TabPanel, {
                        key: tab.id,
                        value: tab.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.tabDataLoading == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_dots_loader)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  (tab.id == 1 && _ctx.presentTaskObject.appId!=10003)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", null, [
                                          _cache[99] || (_cache[99] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                              _createElementVNode("p", { class: "mt-3 mb-1.5 header" }, "Control Info")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                              _cache[97] || (_cache[97] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "CID", -1)),
                                              _createElementVNode("p", _hoisted_14, _toDisplayString((_ctx.presentTaskObject.clientUniqueId != undefined|| _ctx.presentTaskObject.clientUniqueId!='' ) && _ctx.presentTaskObject.hasOwnProperty('clientUniqueId')? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                              _cache[98] || (_cache[98] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "Frequency", -1)),
                                              ((_ctx.presentTaskObject.controlFrequency))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.dbFrequency.find((l) => l.value == _ctx.presentTaskObject.controlFrequency)?.key||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_17, "N/A"))
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _cache[100] || (_cache[100] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title", -1)),
                                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.presentTaskObject?.controlTitle||'N/A'), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_21, [
                                            _cache[101] || (_cache[101] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Category", -1)),
                                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.presentTaskObject?.controlType||'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _cache[102] || (_cache[102] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Class", -1)),
                                            ((_ctx.presentTaskObject?.controlClass))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.presentTaskObject?.controlClass||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_26, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_27, [
                                            _cache[103] || (_cache[103] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Family", -1)),
                                            ((_ctx.presentTaskObject?.controlFamily))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.presentTaskObject?.controlFamily||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_29, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _cache[104] || (_cache[104] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                            (_ctx.presentTaskObject?.controlPriority && typeof _ctx.presentTaskObject?.controlPriority === 'number')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentTaskObject?.controlPriority)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentTaskObject?.controlPriority)])
                                                  }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentTaskObject?.controlPriority)), 3)
                                                ], 2))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_32, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[105] || (_cache[105] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                          ((_ctx.presentTaskObject?.Description))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.presentTaskObject?.Description||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_34, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[106] || (_cache[106] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                          ((_ctx.presentTaskObject?.controlPolicies))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.presentTaskObject?.controlPolicies||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_36, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[107] || (_cache[107] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Guidance", -1)),
                                          ((_ctx.presentTaskObject?.controlGuidance))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.presentTaskObject?.controlGuidance||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_38, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[108] || (_cache[108] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                          ((_ctx.presentTaskObject?.controlMaintenanceTask))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.presentTaskObject?.controlMaintenanceTask||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_40, "N/A"))
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsArray, (control) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: control.framework,
                                            class: "pt-2 pb-3"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(control.controlsDetailsArray, (detail) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: detail.controlNumber
                                              }, [
                                                _createElementVNode("div", _hoisted_41, [
                                                  _createElementVNode("p", _hoisted_42, _toDisplayString(control.framework), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_43, [
                                                  _createElementVNode("div", _hoisted_44, [
                                                    _cache[109] || (_cache[109] = _createElementVNode("div", { class: "w-50 border-t border-l border-r border-b p-2 header border-lightgrey rounded-l-sm" }, [
                                                      _createElementVNode("label", { class: "controllabel" }, "Number")
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_45, [
                                                      _createElementVNode("div", _hoisted_46, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass([_ctx.getBorder(), 'text-xs px-2 py-0.5 bg-white font-bold h-auto flex items-center'])
                                                        }, _toDisplayString(detail.controlNumber), 3)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _cache[110] || (_cache[110] = _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                  _createElementVNode("p", { class: "my-1.5 header" }, "Description")
                                                ], -1)),
                                                (detail.description == null || detail.description == undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString('N/A')))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(detail.description), 1))
                                              ]))
                                            }), 128))
                                          ]))
                                        }), 128)),
                                        (_ctx.kpisObject && _ctx.kpisObject.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _cache[113] || (_cache[113] = _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                _createElementVNode("p", { class: "my-1.5 header" }, "KPI")
                                              ], -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpisObject, (kpi) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: kpi._id
                                                }, [
                                                  _createElementVNode("div", _hoisted_50, [
                                                    _cache[111] || (_cache[111] = _createElementVNode("div", { class: "border-l border-t border-r w-20 border-b p-2 border-lightgrey rounded-l-sm text-sm" }, "Name", -1)),
                                                    _createElementVNode("div", _hoisted_51, _toDisplayString(kpi.description != undefined ? kpi.description : 'N/A'), 1),
                                                    _cache[112] || (_cache[112] = _createElementVNode("div", { class: "border-t border-r border-b p-2 border-lightgrey w-23 text-sm" }, "Weightage (%)", -1)),
                                                    _createElementVNode("div", _hoisted_52, [
                                                      _createElementVNode("div", _hoisted_53, _toDisplayString(kpi.weightage != undefined ? kpi.weightage : 'N/A'), 1)
                                                    ])
                                                  ])
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.presentTaskObject.residual && _ctx.presentTaskObject.residual!='')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                              _cache[126] || (_cache[126] = _createElementVNode("h1", { class: "upperspacing" }, "Inherited Risk", -1)),
                                              _cache[127] || (_cache[127] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                              _createElementVNode("div", _hoisted_55, [
                                                _createElementVNode("div", _hoisted_56, [
                                                  _createElementVNode("div", _hoisted_57, [
                                                    _cache[114] || (_cache[114] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.business)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.business))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.business,1)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_58, [
                                                    _cache[115] || (_cache[115] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.financial)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.financial))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.financial,2)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_59, [
                                                _createElementVNode("div", _hoisted_60, [
                                                  _createElementVNode("div", _hoisted_61, [
                                                    _cache[116] || (_cache[116] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.operations)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.operations))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.operations,3)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_62, [
                                                    _cache[117] || (_cache[117] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.legal)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.legal))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.legal,4)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_63, [
                                                _createElementVNode("div", _hoisted_64, [
                                                  _createElementVNode("div", _hoisted_65, [
                                                    _cache[118] || (_cache[118] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.likelihood)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.likelihood))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.likelihood,5)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_66, [
                                                    _cache[119] || (_cache[119] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.overallImpact)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.overallImpact))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.overallImpact,6)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _cache[128] || (_cache[128] = _createElementVNode("h1", { class: "upperspacing" }, "Residual Risk", -1)),
                                              _cache[129] || (_cache[129] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                              _createElementVNode("div", _hoisted_67, [
                                                _createElementVNode("div", _hoisted_68, [
                                                  _createElementVNode("div", _hoisted_69, [
                                                    _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residual?.business)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residual?.business))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residual?.business,1)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_70, [
                                                    _cache[121] || (_cache[121] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residual?.financial)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residual?.financial))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residual?.financial,2)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_71, [
                                                _createElementVNode("div", _hoisted_72, [
                                                  _createElementVNode("div", _hoisted_73, [
                                                    _cache[122] || (_cache[122] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residual?.operations)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residual?.operations))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residual?.operations,3)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_74, [
                                                    _cache[123] || (_cache[123] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residual?.legal)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residual?.legal))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residual?.legal,4)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_75, [
                                                _createElementVNode("div", _hoisted_76, [
                                                  _createElementVNode("div", _hoisted_77, [
                                                    _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residual?.likelihood)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residual?.likelihood))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residual?.likelihood,5)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_78, [
                                                    _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.overallImpact)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.overallImpact))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.overallImpact,6)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 1 && _ctx.presentTaskObject.appId==10003)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                        _createElementVNode("div", null, [
                                          _cache[140] || (_cache[140] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                              _createElementVNode("p", { class: "mt-3 mb-1.5 header" }, "Risk Info")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_80, [
                                            _createElementVNode("div", _hoisted_81, [
                                              _cache[130] || (_cache[130] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Risk", -1)),
                                              ((_ctx.presentTaskObject.risk||'N/A'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_82, _toDisplayString(_ctx.presentTaskObject.risk ||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_83, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_84, [
                                              _cache[131] || (_cache[131] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Priority", -1)),
                                              (_ctx.presentTaskObject.priority && typeof _ctx.presentTaskObject.priority === 'number')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.riskInformationArray.priority)])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentTaskObject.priority)])
                                                    }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentTaskObject.priority)), 3)
                                                  ], 2))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_85, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_86, [
                                            _createElementVNode("div", _hoisted_87, [
                                              _cache[132] || (_cache[132] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Category", -1)),
                                              ((_ctx.presentTaskObject.riskCategory))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(_ctx.presentTaskObject.riskCategory||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_89, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_90, [
                                              _cache[133] || (_cache[133] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Owner", -1)),
                                              ((_ctx.presentTaskObject.riskOwner))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(_ctx.getRiskOwnerLabel(_ctx.presentTaskObject.riskOwner)||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_92, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_93, [
                                            _createElementVNode("div", _hoisted_94, [
                                              _cache[134] || (_cache[134] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Category", -1)),
                                              ((_ctx.presentTaskObject.threatCategory))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(_ctx.presentTaskObject.threatCategory||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_96, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_97, [
                                              _cache[135] || (_cache[135] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Source", -1)),
                                              ((_ctx.presentTaskObject.threatSource))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(_ctx.presentTaskObject.threatSource||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_99, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_100, [
                                            _cache[136] || (_cache[136] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat", -1)),
                                            ((_ctx.presentTaskObject.threatEvent))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(_ctx.presentTaskObject.threatEvent||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_102, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_103, [
                                            _cache[137] || (_cache[137] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Vulnerability", -1)),
                                            ((_ctx.presentTaskObject.vulnerability))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString(_ctx.presentTaskObject.vulnerability||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_105, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_106, [
                                            _cache[138] || (_cache[138] = _createElementVNode("p", { class: "font-extrabold mb-2 text-xs" }, "Risk Assessment", -1)),
                                            ((_ctx.presentTaskObject.riskAssessment!=''))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(_ctx.presentTaskObject.riskAssessment||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_108, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_109, [
                                            _cache[139] || (_cache[139] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Treatment Summary", -1)),
                                            ((_ctx.presentTaskObject.treatmentType!=''))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_110, _toDisplayString(_ctx.treatmentSummaryData(_ctx.presentTaskObject.treatmentType)||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_111, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[147] || (_cache[147] = _createElementVNode("h1", { class: "upperspacing" }, "Inherited Risk", -1)),
                                          _cache[148] || (_cache[148] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                          _createElementVNode("div", _hoisted_112, [
                                            _createElementVNode("div", _hoisted_113, [
                                              _createElementVNode("div", _hoisted_114, [
                                                _cache[141] || (_cache[141] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.business)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.business))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.business,1)||'N/A'), 3)
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_115, [
                                                _cache[142] || (_cache[142] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.financial)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.financial))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.financial,2)||'N/A'), 3)
                                                ], 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_116, [
                                            _createElementVNode("div", _hoisted_117, [
                                              _createElementVNode("div", _hoisted_118, [
                                                _cache[143] || (_cache[143] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.operations)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.operations))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.operations,3)||'N/A'), 3)
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_119, [
                                                _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.legal)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.legal))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.legal,4)||'N/A'), 3)
                                                ], 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_120, [
                                            _createElementVNode("div", _hoisted_121, [
                                              _createElementVNode("div", _hoisted_122, [
                                                _cache[145] || (_cache[145] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.likelihood)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.likelihood))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.likelihood,5)||'N/A'), 3)
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_123, [
                                                _cache[146] || (_cache[146] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.overallImpact)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.overallImpact))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.overallImpact,6)||'N/A'), 3)
                                                ], 2)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        (_ctx.presentTaskObject.treatmentType && _ctx.presentTaskObject.treatmentType!=10419 && _ctx.presentTaskObject.residualRisk?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                              _cache[155] || (_cache[155] = _createElementVNode("h1", { class: "upperspacing" }, "Residual Risk", -1)),
                                              _cache[156] || (_cache[156] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                              _createElementVNode("div", _hoisted_125, [
                                                _createElementVNode("div", _hoisted_126, [
                                                  _createElementVNode("div", _hoisted_127, [
                                                    _cache[149] || (_cache[149] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residualRisk?.[0]?.business)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.residualRisk?.[0]?.business))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residualRisk?.[0]?.business,1)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_128, [
                                                    _cache[150] || (_cache[150] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residualRisk?.[0]?.financial)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residualRisk?.[0]?.financial))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residualRisk?.[0]?.financial,2)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_129, [
                                                _createElementVNode("div", _hoisted_130, [
                                                  _createElementVNode("div", _hoisted_131, [
                                                    _cache[151] || (_cache[151] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residualRisk?.[0]?.operations)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residualRisk?.[0]?.operations))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residualRisk?.[0]?.operations,3)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_132, [
                                                    _cache[152] || (_cache[152] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residualRisk?.[0]?.legal)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residualRisk?.[0]?.legal))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residualRisk?.[0]?.legal,4)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_133, [
                                                _createElementVNode("div", _hoisted_134, [
                                                  _createElementVNode("div", _hoisted_135, [
                                                    _cache[153] || (_cache[153] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject?.residualRisk?.[0]?.likelihood)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject?.residualRisk?.[0]?.likelihood))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject?.residualRisk?.[0]?.likelihood,5)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_136, [
                                                    _cache[154] || (_cache[154] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentTaskObject.overallImpact)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorLabel(_ctx.presentTaskObject.overallImpact))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentTaskObject.overallImpact,6)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_137, _cache[157] || (_cache[157] = [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                            _createElementVNode("p", { class: "mt-3 mb-1.5 header" }, "Documents which are related to the controls")
                                          ])
                                        ], -1)
                                      ])))
                                    : _createCommentVNode("", true),
                                  (tab.id==3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                        _createElementVNode("div", _hoisted_139, [
                                          _cache[159] || (_cache[159] = _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1.5 header" }, "Related Tasks")
                                          ], -1)),
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["flex justify-between items-center", _ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none': 'filterButton flex justify-center ']),
                                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                                          }, [
                                            (_ctx.tableRow.length == 0)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_140))
                                              : (_openBlock(), _createElementBlock("img", _hoisted_141)),
                                            _cache[158] || (_cache[158] = _createTextVNode(" Filters "))
                                          ], 2)
                                        ]),
                                        _createVNode(_component_tableData, {
                                          tableRowData: _ctx.tableRow,
                                          headersData: _ctx.Headers
                                        }, null, 8, ["tableRowData", "headersData"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                        _createElementVNode("div", _hoisted_143, [
                                          _createElementVNode("div", _hoisted_144, [
                                            _createElementVNode("div", _hoisted_145, [
                                              _createElementVNode("div", _hoisted_146, [
                                                _cache[160] || (_cache[160] = _createElementVNode("div", { class: "my-1.5 header" }, "Files", -1)),
                                                _createElementVNode("div", _hoisted_147, [
                                                  _createElementVNode("button", {
                                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLinkEvidencePopup && _ctx.openLinkEvidencePopup(...args))),
                                                    class: _normalizeClass(_ctx.isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center')
                                                  }, "Link Existing", 2),
                                                  _createElementVNode("button", {
                                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilePopup('file'))),
                                                    class: _normalizeClass(_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418 ||  _ctx.TaskDetailsDropDown.taskStatus == 10401 || !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none ': 'filterButton flex justify-center'),
                                                    for: "upload"
                                                  }, "Attach", 2)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_148, [
                                              (_ctx.fileEvidences.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileEvidences, (doc, idx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 'file-'+idx
                                                      }, [
                                                        _createElementVNode("div", _hoisted_150, [
                                                          _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                            class: "flex w-full flex-row items-center cursor-pointer"
                                                          }, [
                                                            ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_152))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_153))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_154))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_155))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_156))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_157))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_158))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='png')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_159))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_160))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_161))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_162))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_163))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_164))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_165, [
                                                              _createElementVNode("div", _hoisted_166, [
                                                                _createElementVNode("p", {
                                                                  class: "text-xs font-medium truncate",
                                                                  title: doc.filename || doc.name
                                                                }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_167)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_168, [
                                                                _createElementVNode("p", _hoisted_169, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                _createElementVNode("p", _hoisted_170, _toDisplayString(doc.taskId ? doc.taskId : 'N/A'), 1)
                                                              ])
                                                            ]),
                                                            (!_ctx.isPlannerCreatedEvidence(doc))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 13,
                                                                  type: "button",
                                                                  class: _normalizeClass(["evidence-file-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                  onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentTaskObject.files.indexOf(doc))), ["stop","prevent"])
                                                                }, _cache[161] || (_cache[161] = [
                                                                  _createElementVNode("img", {
                                                                    src: _imports_14,
                                                                    alt: "Delete"
                                                                  }, null, -1)
                                                                ]), 10, _hoisted_171))
                                                              : _createCommentVNode("", true)
                                                          ], 8, _hoisted_151)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_172, "No files attached"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_173, [
                                            _createElementVNode("div", _hoisted_174, [
                                              _cache[162] || (_cache[162] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("p", { class: "my-1.5 header" }, "Links")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_175, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openFilePopup('url'))),
                                                  class: _normalizeClass(_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418 ||  _ctx.TaskDetailsDropDown.taskStatus == 10401 || !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none ': 'filterButton flex justify-center')
                                                }, "Add Link", 2)
                                              ])
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["evidence-links-wrap", { 'evidence-links-wrap--empty': _ctx.filteredLinkCount === 0 }])
                                            }, [
                                              _createElementVNode("div", _hoisted_176, [
                                                _createElementVNode("div", _hoisted_177, [
                                                  _createElementVNode("table", {
                                                    class: "evidence-links-table",
                                                    style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                  }, [
                                                    _createElementVNode("thead", null, [
                                                      _createElementVNode("tr", null, [
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-id resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('taskId')),
                                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onLinkHeaderClick('taskId')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_178, [
                                                            _cache[163] || (_cache[163] = _createElementVNode("div", null, "ID", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'taskId' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'taskId')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-title resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('filename')),
                                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onLinkHeaderClick('filename')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_179, [
                                                            _cache[164] || (_cache[164] = _createElementVNode("div", null, "Link Title", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'filename' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'filename')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-link resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('url')),
                                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onLinkHeaderClick('url')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_180, [
                                                            _cache[165] || (_cache[165] = _createElementVNode("div", null, "Link", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'url' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'url')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-date resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('evidenceDate')),
                                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onLinkHeaderClick('evidenceDate')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_181, [
                                                            _cache[166] || (_cache[166] = _createElementVNode("div", null, "Evidence Date", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'evidenceDate' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'evidenceDate')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _cache[167] || (_cache[167] = _createElementVNode("th", { class: "evidence-links-col-action" }, null, -1))
                                                      ])
                                                    ])
                                                  ], 4)
                                                ]),
                                                _createElementVNode("div", _hoisted_182, [
                                                  _createElementVNode("table", {
                                                    class: "evidence-links-table",
                                                    style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                  }, [
                                                    (_ctx.paginatedLinkEvidences.length)
                                                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_183, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLinkEvidences, (doc, idx) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: 'link-'+idx,
                                                              class: "rowHeight evidence-links-row"
                                                            }, [
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-id",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('taskId')),
                                                                title: doc.taskId || 'N/A'
                                                              }, [
                                                                _createElementVNode("div", _hoisted_185, _toDisplayString(doc.taskId || 'N/A'), 1)
                                                              ], 12, _hoisted_184),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-title",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('filename')),
                                                                title: doc.filename || doc.name
                                                              }, [
                                                                _createElementVNode("div", _hoisted_187, _toDisplayString(doc.filename || doc.name || 'N/A'), 1)
                                                              ], 12, _hoisted_186),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-link",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('url'))
                                                              }, [
                                                                _createElementVNode("div", _hoisted_188, [
                                                                  _createElementVNode("a", {
                                                                    href: "#",
                                                                    class: "text-primary evidence-link-anchor cursor-pointer",
                                                                    onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                    title: doc.url
                                                                  }, _toDisplayString(doc.url), 9, _hoisted_189)
                                                                ])
                                                              ], 4),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-date",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('evidenceDate'))
                                                              }, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 5),
                                                              _createElementVNode("td", _hoisted_190, [
                                                                (!_ctx.isPlannerCreatedEvidence(doc))
                                                                  ? (_openBlock(), _createElementBlock("button", {
                                                                      key: 0,
                                                                      type: "button",
                                                                      class: _normalizeClass(["evidence-links-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                      onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentTaskObject.files.indexOf(doc))), ["stop","prevent"])
                                                                    }, _cache[168] || (_cache[168] = [
                                                                      _createElementVNode("img", {
                                                                        src: _imports_14,
                                                                        alt: "Delete",
                                                                        class: "h-5 w-5"
                                                                      }, null, -1)
                                                                    ]), 10, _hoisted_191))
                                                                  : _createCommentVNode("", true)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("tbody", _hoisted_192, _cache[169] || (_cache[169] = [
                                                          _createElementVNode("tr", null, [
                                                            _createElementVNode("td", {
                                                              class: "evidence-links-empty",
                                                              colspan: "5"
                                                            }, [
                                                              _createElementVNode("div", { class: "flex justify-center" }, [
                                                                _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                              ])
                                                            ])
                                                          ], -1)
                                                        ])))
                                                  ], 4)
                                                ])
                                              ]),
                                              (_ctx.filteredLinkCount > 0)
                                                ? (_openBlock(), _createBlock(_component_pagination, {
                                                    key: 0,
                                                    dynamicPagination: _ctx.filteredLinkCount,
                                                    sortedData: _ctx.sortedLinkEvidences,
                                                    onCurrentPageUpdate: _ctx.onLinkPaginationUpdate
                                                  }, null, 8, ["dynamicPagination", "sortedData", "onCurrentPageUpdate"]))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_194, [
                                            _cache[172] || (_cache[172] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-1.5 header" }, "Comments")
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_195, [
                                                _createElementVNode("div", _hoisted_196, [
                                                  (_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: _normalizeClass(["filterButton flex", Object.keys(this.presentTaskObject).includes('comments') && this.presentTaskObject.comments.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none']),
                                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortComments()))
                                                      }, _cache[170] || (_cache[170] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ]), 2))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton flex",
                                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortComments()))
                                                      }, _cache[171] || (_cache[171] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_197, [
                                              _createElementVNode("div", _hoisted_198, [
                                                (_ctx.TaskDetailsDropDown.taskStatus!=10403 && _ctx.TaskDetailsDropDown.taskStatus!=10418 && _ctx.TaskDetailsDropDown.taskStatus!=10417 && _ctx.isAddDisabled(10302))
                                                  ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                                      key: 0,
                                                      taskStatusCode: _ctx.TaskDetailsDropDown.taskStatus
                                                    }, null, 8, ["taskStatusCode"]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            (Object.keys(_ctx.presentTaskObject).includes('comments'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.comments, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-2",
                                                      key: index
                                                    }, [
                                                      (Object.keys(obj).includes('createdBy'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_200, _toDisplayString(_ctx.extractInitials(obj.name)), 1))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(obj).includes('updatedBy'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_201, _toDisplayString(_ctx.extractInitials(obj.name)), 1))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_202, [
                                                        _createElementVNode("div", _hoisted_203, _toDisplayString(obj.name), 1),
                                                        _createElementVNode("div", _hoisted_204, _toDisplayString(_ctx.formatTime( obj.createdAt )), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_205, [
                                                        _createVNode(_component_safeHtml, {
                                                          content: obj.comment
                                                        }, null, 8, ["content"])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==6)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_207, [
                                            _createElementVNode("div", _hoisted_208, [
                                              _cache[173] || (_cache[173] = _createElementVNode("div", { class: "my-1.5 header" }, "Findings", -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showpopupOnAdd())),
                                                  class: _normalizeClass(
                                          (
                                          (_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418 ||  _ctx.TaskDetailsDropDown.taskStatus == 10401) 
                                          ||   (_ctx.userInfo?.role_id === 10217 && _ctx.presentTaskObject.reviewer?.value !== _ctx.userInfo._id)
                                          ) 
                                          || _ctx.userInfo?.role_id==10217 || !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none ': 'filterButton flex justify-center')
                                                }, "Add Findings", 2)
                                              ])
                                            ])
                                          ]),
                                          (Object.keys(_ctx.presentTaskObject).includes('findings'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingsForCompliance, (obj, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: _normalizeClass(["w-full h-auto mt-5 relative", _ctx.canEditFindingDraft() ? 'cursor-pointer' : '']),
                                                    onClick: ($event: any) => (_ctx.onFindingCardClick(obj))
                                                  }, [
                                                    (_ctx.canEditFindingDraft())
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          type: "button",
                                                          class: "absolute top-2 right-2 z-10 p-1 rounded hover:bg-gray-100",
                                                          title: "Delete finding",
                                                          onClick: _withModifiers(($event: any) => (_ctx.openDeleteFindingConfirm(obj)), ["stop"])
                                                        }, _cache[174] || (_cache[174] = [
                                                          _createElementVNode("img", {
                                                            src: _imports_14,
                                                            class: "h-4 w-4",
                                                            alt: "Delete"
                                                          }, null, -1)
                                                        ]), 8, _hoisted_211))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_212, [
                                                      _cache[175] || (_cache[175] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Finding ID", -1)),
                                                      _createElementVNode("div", _hoisted_213, _toDisplayString(obj.findingId?.toUpperCase()), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_214, [
                                                      _cache[176] || (_cache[176] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding", -1)),
                                                      _createElementVNode("div", _hoisted_215, _toDisplayString(obj.finding), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_216, [
                                                      _cache[177] || (_cache[177] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Evidence", -1)),
                                                      _createElementVNode("div", _hoisted_217, _toDisplayString(obj.findingEvidence), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_218, [
                                                      _cache[178] || (_cache[178] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding Severity", -1)),
                                                      _createElementVNode("div", _hoisted_219, [
                                                        (_ctx.getFindingSeverityValue(obj) != null)
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 0,
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.reviewScaleChipBg(_ctx.controlRiskSeverityLabelOptions, _ctx.getFindingSeverityValue(obj))]),
                                                              title: _ctx.getFindingSeverityLabel(obj)
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(_ctx.controlRiskSeverityLabelOptions, _ctx.getFindingSeverityValue(obj))])
                                                              }, _toDisplayString(_ctx.getFindingSeverityLabel(obj)), 3)
                                                            ], 10, _hoisted_220))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_221, "N/A"))
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_222, [
                                                      _cache[179] || (_cache[179] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Related To", -1)),
                                                      _createElementVNode("div", _hoisted_223, _toDisplayString(_ctx.getFindingRelatedToDisplay(obj.findingRelatedTo)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_224, [
                                                      _createElementVNode("div", _hoisted_225, _toDisplayString(_ctx.getFindingLinkFieldLabel(obj)), 1),
                                                      _createElementVNode("div", _hoisted_226, _toDisplayString(_ctx.getFindingLinkDisplay(obj)), 1)
                                                    ])
                                                  ], 10, _hoisted_210))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==7)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_228, [
                                            _createElementVNode("div", _hoisted_229, [
                                              _cache[180] || (_cache[180] = _createElementVNode("div", { class: "my-1.5 header" }, "Result", -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showpopupOnAddForResult('addresult'))),
                                                  class: _normalizeClass(_ctx.conditionForResultBtn() ||(!_ctx.presentTaskObject.kpis&& (Object.keys(_ctx.presentTaskObject).includes('controlResults') && _ctx.presentTaskObject.controlResults?.length != 0) || _ctx.presentTaskObject?.controlResults?.length==1) || (_ctx.presentTaskObject.reviewer?.value!=_ctx.userInfo._id && _ctx.userInfo?.role_id === 10217) || !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none': 'filterButton flex justify-center')
                                                }, "Add Result", 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            (_ctx.controlResultsForCompliance.length != 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlResultsForCompliance, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: index,
                                                      class: _normalizeClass(["w-full", _ctx.canEditResultDraft() ? 'cursor-pointer' : '']),
                                                      onClick: _withModifiers(($event: any) => (_ctx.onControlResultCardClick(obj)), ["stop"])
                                                    }, [
                                                      _createElementVNode("div", _hoisted_232, [
                                                        _cache[181] || (_cache[181] = _createElementVNode("div", { class: "border-l headerData border-t border-b p-2 text-xs w-23 border-lightgrey rounded-tl-md" }, "Control ID ", -1)),
                                                        _createElementVNode("div", _hoisted_233, _toDisplayString(_ctx.presentTaskObject.clientUniqueId != undefined ? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1),
                                                        _cache[182] || (_cache[182] = _createElementVNode("div", { class: "border-l border-t border-b p-2 headerData w-23 border-lightgrey" }, "Risk Severity ", -1)),
                                                        _createElementVNode("div", _hoisted_234, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.reviewScaleChipBg(_ctx.controlRiskSeverityLabelOptions, obj.severity)])
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(_ctx.controlRiskSeverityLabelOptions, obj.severity)])
                                                            }, _toDisplayString(_ctx.getReviewScaleLabel(_ctx.controlRiskSeverityLabelOptions, obj.severity)), 3)
                                                          ], 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_235, [
                                                        _cache[183] || (_cache[183] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Title", -1)),
                                                        _createElementVNode("div", _hoisted_236, _toDisplayString(_ctx.presentTaskObject.appId==10003?_ctx.riskInformationArray.risk: _ctx.presentTaskObject.controlTitle), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_237, [
                                                        _cache[184] || (_cache[184] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Population ", -1)),
                                                        _createElementVNode("div", _hoisted_238, _toDisplayString(obj.totalPopulation == null || obj.totalPopulation === '' ? 'N/A' : obj.totalPopulation), 1),
                                                        _cache[185] || (_cache[185] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Compliant ", -1)),
                                                        _createElementVNode("div", _hoisted_239, _toDisplayString(obj.actualOutput == null || obj.actualOutput === '' ? 'N/A' : obj.actualOutput), 1)
                                                      ]),
                                                      (obj.resultfor == 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                                                            _cache[186] || (_cache[186] = _createElementVNode("div", { class: "border-l border-b p-2 headerData flex items-center w-23 border-lightgrey" }, "Performance Analysis", -1)),
                                                            _createElementVNode("div", _hoisted_241, [
                                                              (obj.controlResultValue == null || obj.controlResultValue === '')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_242, "N/A"))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                                                    _createElementVNode("div", _hoisted_244, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["progress-bar", _ctx.getPerformanceBg(obj.controlResultValue)]),
                                                                        style: _normalizeStyle({ width: `${obj.controlResultValue}%` })
                                                                      }, null, 6)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_245, [
                                                                      (obj.controlResultValue >= 50)
                                                                        ? (_openBlock(), _createElementBlock("p", {
                                                                            key: 0,
                                                                            class: "indicator mt-1",
                                                                            style: _normalizeStyle({left: `calc(${obj.controlResultValue}% - 20px)`})
                                                                          }, _toDisplayString(obj.controlResultValue) + "%", 5))
                                                                        : (_openBlock(), _createElementBlock("p", {
                                                                            key: 1,
                                                                            class: "indicator mt-1",
                                                                            style: _normalizeStyle({left: `calc(${obj.controlResultValue}%)`})
                                                                          }, _toDisplayString(obj.controlResultValue) + "%", 5))
                                                                    ])
                                                                  ]))
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_246, [
                                                        _cache[187] || (_cache[187] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey flex items-center" }, "Health", -1)),
                                                        _createElementVNode("div", _hoisted_247, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.reviewScaleChipBg(_ctx.healthLabelOptions, obj.reviewHealth)])
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(_ctx.healthLabelOptions, obj.reviewHealth)])
                                                            }, _toDisplayString(_ctx.getReviewScaleLabel(_ctx.healthLabelOptions, obj.reviewHealth)), 3)
                                                          ], 2)
                                                        ]),
                                                        _cache[188] || (_cache[188] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Operating Effectiveness", -1)),
                                                        _createElementVNode("div", _hoisted_248, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.reviewScaleChipBg(_ctx.operatingEffectivenessLabelOptions, obj.operatingEffectiveness)]),
                                                            title: _ctx.getReviewScaleLabel(_ctx.operatingEffectivenessLabelOptions, obj.operatingEffectiveness)
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(_ctx.operatingEffectivenessLabelOptions, obj.operatingEffectiveness)])
                                                            }, _toDisplayString(_ctx.getReviewScaleLabel(_ctx.operatingEffectivenessLabelOptions, obj.operatingEffectiveness)), 3)
                                                          ], 10, _hoisted_249)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_250, [
                                                        _cache[189] || (_cache[189] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey rounded-bl-md" }, "Conclusion", -1)),
                                                        _createElementVNode("div", _hoisted_251, _toDisplayString(obj.comments == null || obj.comments === '' ? 'N/A' : obj.comments), 1)
                                                      ])
                                                    ], 10, _hoisted_231))
                                                  }), 128))
                                                ]))
                                              : (_ctx.controlResultsForCompliance.length <= 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["w-full", _ctx.canAddControlResult() ? 'cursor-pointer' : '']),
                                                      onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.onEmptyControlResultClick()), ["stop"]))
                                                    }, [
                                                      _createElementVNode("div", _hoisted_253, [
                                                        _cache[190] || (_cache[190] = _createElementVNode("div", { class: "border-l border-t border-b p-2 headerData w-23 border-lightgrey rounded-tl-md" }, "Control ID ", -1)),
                                                        _createElementVNode("div", _hoisted_254, _toDisplayString(_ctx.presentTaskObject.clientUniqueId != undefined ? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1),
                                                        _cache[191] || (_cache[191] = _createElementVNode("div", { class: "border-l border-t border-b p-2 headerData w-23 border-lightgrey" }, "Risk Severity ", -1)),
                                                        _cache[192] || (_cache[192] = _createElementVNode("div", { class: "border-l border-t border-b border-r border-lightgrey w-27 p-2 rounded-tr-md" }, null, -1))
                                                      ]),
                                                      _createElementVNode("div", _hoisted_255, [
                                                        _cache[193] || (_cache[193] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Title", -1)),
                                                        _createElementVNode("div", _hoisted_256, _toDisplayString(_ctx.presentTaskObject.appId==10003?_ctx.riskInformationArray.risk: _ctx.presentTaskObject.controlTitle), 1)
                                                      ]),
                                                      _cache[194] || (_cache[194] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Population "),
                                                        _createElementVNode("div", { class: "border-b border-l border-lightgrey w-27 p-2" }),
                                                        _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Compliant "),
                                                        _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-27 p-2" })
                                                      ], -1)),
                                                      _cache[195] || (_cache[195] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 flex items-center headerData w-23 border-lightgrey" }, "Performance Analysis"),
                                                        _createElementVNode("div", { class: "border-l border-r border-b header border-lightgrey w-77 p-2 h-14" }, [
                                                          _createElementVNode("div", { class: "ml-2 mr-2" }, [
                                                            _createElementVNode("div", { class: "progress-container" }, [
                                                              _createElementVNode("div", { class: "progress-bar" })
                                                            ]),
                                                            _createElementVNode("div", null, [
                                                              _createElementVNode("div", { class: "progress-indicator-count" }, [
                                                                _createElementVNode("p", {
                                                                  class: "indicator",
                                                                  style: {left: `calc(${0}%)`}
                                                                }, _toDisplayString(0) + "%")
                                                              ])
                                                            ])
                                                          ])
                                                        ])
                                                      ], -1)),
                                                      _cache[196] || (_cache[196] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Health"),
                                                        _createElementVNode("div", { class: "border-b border-l border-lightgrey w-27 p-2" }),
                                                        _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Operating Effectiveness"),
                                                        _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-27 p-2" })
                                                      ], -1)),
                                                      _cache[197] || (_cache[197] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey rounded-bl-md" }, "Conclusion"),
                                                        _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs rounded-br-md" })
                                                      ], -1))
                                                    ], 2)
                                                  ]))
                                                : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.presentTaskObject.kpis && _ctx.presentTaskObject.kpis.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                                _createElementVNode("div", _hoisted_258, [
                                                  _cache[198] || (_cache[198] = _createElementVNode("div", { class: "my-1.5 header" }, "KPI Result", -1)),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("button", {
                                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showpopupOnAddForResult('addkpi'))),
                                                      class: _normalizeClass(_ctx.conditionForResultBtn() || ((_ctx.presentTaskObject.hasOwnProperty('kpis') || !_ctx.presentTaskObject.hasOwnProperty('kpis')) && (_ctx.presentTaskObject.reviewer?.value!==_ctx.userInfo._id && _ctx.userInfo?.role_id==10217) || this.presentTaskObject.kpis.length===this.presentTaskObject.results?.length) ||  !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none': 'filterButton flex justify-center taskEditButtons')
                                                    }, "Add Result", 2)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.resultsForCompliance.length != 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.presentTaskObject.results || []), (obj, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: _normalizeClass(["w-full", _ctx.canEditResultDraft() ? 'cursor-pointer' : '']),
                                                    onClick: _withModifiers(($event: any) => (_ctx.onKpiResultCardClick(obj)), ["stop"])
                                                  }, [
                                                    _createElementVNode("div", _hoisted_261, [
                                                      _cache[199] || (_cache[199] = _createElementVNode("div", { class: "border-l border-t border-b p-2 headerData w-23 border-lightgrey rounded-tl-md" }, "KPI ID", -1)),
                                                      _createElementVNode("div", _hoisted_262, _toDisplayString((_ctx.presentTaskObject.kpis || []).find((kpi)=>kpi._id == obj.controlorKpi)?.kpi_id), 1),
                                                      _cache[200] || (_cache[200] = _createElementVNode("div", { class: "border-t border-b p-2 headerData w-23 border-lightgrey" }, "Result", -1)),
                                                      _createElementVNode("div", _hoisted_263, [
                                                        (_ctx.getKpiPassFail(obj) === 'Pass')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_264, _toDisplayString(_ctx.getKpiPassFail(obj)), 1))
                                                          : (_ctx.getKpiPassFail(obj) === 'Fail')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_265, _toDisplayString(_ctx.getKpiPassFail(obj)), 1))
                                                            : (_ctx.getKpiPassFail(obj) === 'No Instances')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_266, _toDisplayString(_ctx.getKpiPassFail(obj)), 1))
                                                              : _createCommentVNode("", true)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_267, [
                                                      _cache[201] || (_cache[201] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Title", -1)),
                                                      _createElementVNode("div", _hoisted_268, _toDisplayString((_ctx.presentTaskObject.kpis || []).find((kpi)=>kpi._id == obj.controlorKpi)?.description), 1),
                                                      _cache[202] || (_cache[202] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Risk Severity", -1)),
                                                      _createElementVNode("div", _hoisted_269, [
                                                        (_ctx.isKpiNoInstances(obj))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_270, "N/A"))
                                                          : (_openBlock(), _createElementBlock("div", {
                                                              key: 1,
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(obj.severity)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorRiskText(obj.severity))
                                                              }, _toDisplayString(_ctx.getSeverityLabel(obj.severity)), 3)
                                                            ], 2))
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_271, [
                                                      _cache[203] || (_cache[203] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Target Type", -1)),
                                                      _createElementVNode("div", _hoisted_272, _toDisplayString(_ctx.getKpiTargetTypeLabel(obj.targetType || (_ctx.presentTaskObject.kpis || []).find((kpi)=>kpi._id == obj.controlorKpi)?.targetType || 'percentage')), 1),
                                                      _cache[204] || (_cache[204] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Condition", -1)),
                                                      _createElementVNode("div", _hoisted_273, _toDisplayString(_ctx.getKpiConditionLabel(obj.kpiCondition || (_ctx.presentTaskObject.kpis || []).find((kpi)=>kpi._id == obj.controlorKpi)?.kpiCondition) || 'N/A'), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_274, [
                                                      _cache[205] || (_cache[205] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Target", -1)),
                                                      _createElementVNode("div", _hoisted_275, _toDisplayString(_ctx.getKpiTargetDisplay(obj)), 1),
                                                      _cache[206] || (_cache[206] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Achieved", -1)),
                                                      _createElementVNode("div", _hoisted_276, _toDisplayString(_ctx.getKpiActualDisplay(obj)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_277, [
                                                      _cache[207] || (_cache[207] = _createElementVNode("div", { class: "border-l p-2 headerData w-23 border-lightgrey" }, "Population ", -1)),
                                                      _createElementVNode("div", _hoisted_278, _toDisplayString(obj.totalPopulation == null || obj.totalPopulation === '' ? 'N/A' : obj.totalPopulation), 1),
                                                      _cache[208] || (_cache[208] = _createElementVNode("div", { class: "border-l p-2 headerData w-23 border-lightgrey" }, "Compliant ", -1)),
                                                      _createElementVNode("div", _hoisted_279, _toDisplayString(_ctx.getKpiCompliantDisplay(obj)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_280, [
                                                      _cache[209] || (_cache[209] = _createElementVNode("div", { class: "border-t border-l border-b p-2 headerData w-23 border-lightgrey rounded-bl-md" }, "Comments", -1)),
                                                      _createElementVNode("div", _hoisted_281, _toDisplayString(obj.comments == null || obj.comments === '' ? 'N/A' : obj.comments), 1)
                                                    ])
                                                  ], 10, _hoisted_260))
                                                }), 128))
                                              ]))
                                            : (_ctx.resultsForCompliance.length == 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_282, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.kpis, (i) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                                                      ((_ctx.presentTaskObject.kpis != null || _ctx.presentTaskObject.kpis != undefined) && (_ctx.presentTaskObject.kpis.length > 0))
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["w-full", _ctx.canAddKpiResult(i) ? 'cursor-pointer' : '']),
                                                            onClick: _withModifiers(($event: any) => (_ctx.onEmptyKpiResultClick(i)), ["stop"])
                                                          }, [
                                                            _createElementVNode("div", _hoisted_284, [
                                                              _cache[210] || (_cache[210] = _createElementVNode("div", { class: "border-l border-t border-b p-2 headerData w-23 border-lightgrey rounded-tl-md" }, "KPI ID", -1)),
                                                              _createElementVNode("div", _hoisted_285, _toDisplayString(i.kpi_id), 1),
                                                              _cache[211] || (_cache[211] = _createElementVNode("div", { class: "border-t border-l border-b p-2 headerData w-23 border-lightgrey" }, "Result", -1)),
                                                              _cache[212] || (_cache[212] = _createElementVNode("div", { class: "border-t border-r border-b border-l border-lightgrey w-27 p-2 rounded-tr-md" }, null, -1))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_286, [
                                                              _cache[213] || (_cache[213] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Title", -1)),
                                                              _createElementVNode("div", _hoisted_287, _toDisplayString(i.description), 1),
                                                              _cache[214] || (_cache[214] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Risk Severity", -1)),
                                                              _cache[215] || (_cache[215] = _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-27 p-2" }, null, -1))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_288, [
                                                              _cache[216] || (_cache[216] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Target Type", -1)),
                                                              _createElementVNode("div", _hoisted_289, _toDisplayString(_ctx.getKpiTargetTypeLabel(i.targetType || 'percentage')), 1),
                                                              _cache[217] || (_cache[217] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Condition", -1)),
                                                              _createElementVNode("div", _hoisted_290, _toDisplayString(_ctx.getKpiConditionLabel(i.kpiCondition || i.targetOperator || i.logic)||'N/A'), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_291, [
                                                              _cache[218] || (_cache[218] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Target", -1)),
                                                              _createElementVNode("div", _hoisted_292, _toDisplayString(i.target||'N/A'), 1),
                                                              _cache[219] || (_cache[219] = _createElementVNode("div", { class: "border-l border-b p-2 headerData w-23 border-lightgrey" }, "Achieved", -1)),
                                                              _cache[220] || (_cache[220] = _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-27 p-2" }, null, -1))
                                                            ]),
                                                            _cache[221] || (_cache[221] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                              _createElementVNode("div", { class: "border-l p-2 headerData w-23 border-lightgrey" }, "Population "),
                                                              _createElementVNode("div", { class: "border-l border-lightgrey w-27 p-2" }),
                                                              _createElementVNode("div", { class: "border-l p-2 headerData w-23 border-lightgrey" }, "Compliant "),
                                                              _createElementVNode("div", { class: "border-r border-l border-lightgrey w-27 p-2" })
                                                            ], -1)),
                                                            _cache[222] || (_cache[222] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                              _createElementVNode("div", { class: "border-t border-l border-b p-2 headerData w-23 border-lightgrey rounded-bl-md" }, "Comments"),
                                                              _createElementVNode("div", { class: "border-r border-t border-b border-l border-lightgrey w-77 p-2 rounded-br-md" })
                                                            ], -1))
                                                          ], 10, _hoisted_283))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true),
                                          (_ctx.presentTaskObject.results?.length && _ctx.presentTaskObject.kpis?.length && _ctx.presentTaskObject.kpis.length != _ctx.presentTaskObject.results.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.kpis.filter(kpi => !(_ctx.presentTaskObject.results || []).find(r => r.controlorKpi === kpi._id)), (data, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: _normalizeClass(["w-full mt-5", _ctx.canAddKpiResult(data) ? 'cursor-pointer' : '']),
                                                    onClick: _withModifiers(($event: any) => (_ctx.onEmptyKpiResultClick(data)), ["stop"])
                                                  }, [
                                                    _createElementVNode("div", _hoisted_295, [
                                                      _cache[223] || (_cache[223] = _createElementVNode("div", { class: "border-l border-t border-b p-2 headerData w-23 border-lightgrey rounded-tl-md" }, "KPI ID", -1)),
                                                      _createElementVNode("div", _hoisted_296, _toDisplayString(data.kpi_id||'N/A'), 1),
                                                      _cache[224] || (_cache[224] = _createElementVNode("div", { class: "border-t border-b p-2 headerData w-23 border-lightgrey" }, "Result", -1)),
                                                      _cache[225] || (_cache[225] = _createElementVNode("div", { class: "border-t border-b border-l border-r border-lightgrey w-27 p-2 rounded-tr-md" }, null, -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_297, [
                                                      _cache[226] || (_cache[226] = _createElementVNode("div", { class: "border-l p-2 border-b headerData w-23 border-lightgrey" }, "Title", -1)),
                                                      _createElementVNode("div", _hoisted_298, _toDisplayString(data.description||'N/A'), 1),
                                                      _cache[227] || (_cache[227] = _createElementVNode("div", { class: "border-l p-2 border-b headerData w-23 border-lightgrey" }, "Risk Severity", -1)),
                                                      _cache[228] || (_cache[228] = _createElementVNode("div", { class: "border-r border-l border-b border-lightgrey w-27 p-2" }, null, -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_299, [
                                                      _cache[229] || (_cache[229] = _createElementVNode("div", { class: "border-l p-2 border-b headerData w-23 border-lightgrey" }, "Target Type", -1)),
                                                      _createElementVNode("div", _hoisted_300, _toDisplayString(_ctx.getKpiTargetTypeLabel(data.targetType || 'percentage')), 1),
                                                      _cache[230] || (_cache[230] = _createElementVNode("div", { class: "border-l p-2 border-b headerData w-23 border-lightgrey" }, "Condition", -1)),
                                                      _createElementVNode("div", _hoisted_301, _toDisplayString(_ctx.getKpiConditionLabel(data.kpiCondition || data.targetOperator || data.logic) || 'N/A'), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_302, [
                                                      _cache[231] || (_cache[231] = _createElementVNode("div", { class: "border-l p-2 border-b headerData w-23 border-lightgrey" }, "Target", -1)),
                                                      _createElementVNode("div", _hoisted_303, _toDisplayString(data.target||'N/A'), 1),
                                                      _cache[232] || (_cache[232] = _createElementVNode("div", { class: "border-l p-2 border-b headerData w-23 border-lightgrey" }, "Achieved", -1)),
                                                      _cache[233] || (_cache[233] = _createElementVNode("div", { class: "border-r border-l border-b border-lightgrey w-27 p-2" }, null, -1))
                                                    ]),
                                                    _cache[234] || (_cache[234] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                      _createElementVNode("div", { class: "border-l p-2 headerData w-23 border-lightgrey" }, "Population "),
                                                      _createElementVNode("div", { class: "border-l border-lightgrey w-27 p-2" }),
                                                      _createElementVNode("div", { class: "border-l p-2 headerData w-23 border-lightgrey" }, "Compliant "),
                                                      _createElementVNode("div", { class: "border-r border-l border-lightgrey w-27 p-2" })
                                                    ], -1)),
                                                    _cache[235] || (_cache[235] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                      _createElementVNode("div", { class: "border-t border-l border-b p-2 headerData w-23 border-lightgrey rounded-bl-md" }, "Comments"),
                                                      _createElementVNode("div", { class: "border-r border-t border-b border-l border-lightgrey w-77 p-2 rounded-br-md" })
                                                    ], -1))
                                                  ], 10, _hoisted_294))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==8)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_304, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_305, [
                                            _cache[238] || (_cache[238] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-1.5 header" }, "Work History")
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_306, [
                                                _createElementVNode("div", _hoisted_307, [
                                                  (_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: _normalizeClass(["filterButton flex", Object.keys(this.workLogObject).includes('taskHistory') && this.workLogObject.taskHistory.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none']),
                                                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[236] || (_cache[236] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ]), 2))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton flex",
                                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[237] || (_cache[237] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: work,
                                              class: "bg-white py-4 border-lightgrey border-b w-full"
                                            }, [
                                              _createElementVNode("div", _hoisted_308, [
                                                (Object.keys(work).includes('createdBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_309, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                  : _createCommentVNode("", true),
                                                (Object.keys(work).includes('updatedBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_310, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_311, [
                                                  _createElementVNode("div", _hoisted_312, [
                                                    (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_313, _toDisplayString(work.name), 1))
                                                      : (Object.keys(work).includes('updatedBy') && !Object.keys(work).includes('additionalInfo'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_314, _toDisplayString(work.name), 1))
                                                        : (Object.keys(work).includes('updatedBy') && Object.keys(work).includes('additionalInfo'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_315, _toDisplayString(work.name), 1))
                                                          : _createCommentVNode("", true),
                                                    (work.actionEntity == 10301)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_316, _toDisplayString('Created the Task on')))
                                                      : (work.actionEntity == 10302)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_317, _toDisplayString('Updated the Task on')))
                                                        : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('createdAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_318, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('updatedAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_319, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (work.additionalInfo != null && Object.keys(work).includes('additionalInfo'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_320, [
                                                        (Object.keys(work.additionalInfo).includes('comment'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_321, [
                                                              _cache[239] || (_cache[239] = _createElementVNode("div", { class: "w-1/6" }, [
                                                                _createElementVNode("p", { class: "font-semibold text-xs w-12" }, _toDisplayString('Comment:'))
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_322, [
                                                                _createVNode(_component_safeHtml, {
                                                                  content: work.additionalInfo.comment
                                                                }, null, 8, ["content"])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('actualOutput'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_323, [
                                                              _cache[243] || (_cache[243] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs pr-2" }, _toDisplayString('Added the Result -'), -1)),
                                                              _cache[244] || (_cache[244] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Compliant (A) :'), -1)),
                                                              _createElementVNode("p", _hoisted_324, _toDisplayString(work.additionalInfo.actualOutput), 1),
                                                              _cache[245] || (_cache[245] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Population (B) :'), -1)),
                                                              _createElementVNode("p", _hoisted_325, _toDisplayString(work.additionalInfo.totalPopulation), 1),
                                                              (work.additionalInfo.riskSeverity != null && work.additionalInfo.riskSeverity !== '')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _cache[240] || (_cache[240] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Risk Severity :'), -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", Number(work.additionalInfo.resultfor) === 1 ? _ctx.reviewScaleChipBg(_ctx.controlRiskSeverityLabelOptions, work.additionalInfo.riskSeverity) : _ctx.colorRiskBg(work.additionalInfo.riskSeverity)])
                                                                    }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["truncate whitespace-nowrap", Number(work.additionalInfo.resultfor) === 1 ? _ctx.reviewScaleChipText(_ctx.controlRiskSeverityLabelOptions, work.additionalInfo.riskSeverity) : _ctx.colorRiskText(work.additionalInfo.riskSeverity)])
                                                                      }, _toDisplayString(Number(work.additionalInfo.resultfor) === 1 ? _ctx.getReviewScaleLabel(_ctx.controlRiskSeverityLabelOptions, work.additionalInfo.riskSeverity) : _ctx.getSeverityLabel(work.additionalInfo.riskSeverity)), 3)
                                                                    ], 2)
                                                                  ], 64))
                                                                : _createCommentVNode("", true),
                                                              (Number(work.additionalInfo.resultfor) === 1 && work.additionalInfo.reviewHealth != null && work.additionalInfo.reviewHealth !== '')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _cache[241] || (_cache[241] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Health :'), -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", _ctx.reviewScaleChipBg(_ctx.healthLabelOptions, work.additionalInfo.reviewHealth)]),
                                                                      title: _ctx.getReviewScaleLabel(_ctx.healthLabelOptions, work.additionalInfo.reviewHealth)
                                                                    }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(_ctx.healthLabelOptions, work.additionalInfo.reviewHealth)])
                                                                      }, _toDisplayString(_ctx.getReviewScaleLabel(_ctx.healthLabelOptions, work.additionalInfo.reviewHealth)), 3)
                                                                    ], 10, _hoisted_326)
                                                                  ], 64))
                                                                : _createCommentVNode("", true),
                                                              (Number(work.additionalInfo.resultfor) === 1 && work.additionalInfo.operatingEffectiveness != null && work.additionalInfo.operatingEffectiveness !== '')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                    _cache[242] || (_cache[242] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Operating Effectiveness :'), -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", _ctx.reviewScaleChipBg(_ctx.operatingEffectivenessLabelOptions, work.additionalInfo.operatingEffectiveness)]),
                                                                      title: _ctx.getReviewScaleLabel(_ctx.operatingEffectivenessLabelOptions, work.additionalInfo.operatingEffectiveness)
                                                                    }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(_ctx.operatingEffectivenessLabelOptions, work.additionalInfo.operatingEffectiveness)])
                                                                      }, _toDisplayString(_ctx.getReviewScaleLabel(_ctx.operatingEffectivenessLabelOptions, work.additionalInfo.operatingEffectiveness)), 3)
                                                                    ], 10, _hoisted_327)
                                                                  ], 64))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (work.additionalInfo.findingIds && work.additionalInfo.findingIds.length)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_328, [
                                                              _cache[246] || (_cache[246] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Findings -'), -1)),
                                                              _createElementVNode("p", _hoisted_329, _toDisplayString((work.additionalInfo.findingIds || []).map((id) => String(id).toUpperCase()).join(', ')), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('updatedActualOutput'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_330, [
                                                              _cache[249] || (_cache[249] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs pr-2" }, _toDisplayString('Updated the Result -'), -1)),
                                                              (!(work.additionalInfo.changes && work.additionalInfo.changes.length))
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _cache[247] || (_cache[247] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Compliant (A) :'), -1)),
                                                                    _createElementVNode("p", _hoisted_331, _toDisplayString(work.additionalInfo.updatedActualOutput), 1),
                                                                    _cache[248] || (_cache[248] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Population (B) :'), -1)),
                                                                    _createElementVNode("p", _hoisted_332, _toDisplayString(work.additionalInfo.totalPopulation), 1)
                                                                  ], 64))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('findingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_333, [
                                                              _cache[250] || (_cache[250] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Added the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_334, _toDisplayString(work.additionalInfo.findingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('deletedFindingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_335, [
                                                              _cache[251] || (_cache[251] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Removed the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_336, _toDisplayString(work.additionalInfo.deletedFindingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('updatedFindingId') && !(work.additionalInfo.changes && work.additionalInfo.changes.length) && !(work.additionalInfo.addedAttachments && work.additionalInfo.addedAttachments.length) && !(work.additionalInfo.removedAttachments && work.additionalInfo.removedAttachments.length))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_337, [
                                                              _cache[252] || (_cache[252] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Updated the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_338, _toDisplayString(work.additionalInfo.updatedFindingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('findingRelatedToLabel') && !work.additionalInfo.resultFindingsSync && !_ctx.hasFindingRelatedToChange(work.additionalInfo))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_339, [
                                                              _cache[253] || (_cache[253] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Related To -'), -1)),
                                                              _createElementVNode("p", _hoisted_340, _toDisplayString(work.additionalInfo.findingRelatedToLabel), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('controlTitle') && work.additionalInfo.controlTitle && !work.additionalInfo.resultFindingsSync && !_ctx.hasFindingRelatedToChange(work.additionalInfo))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                                                              _cache[254] || (_cache[254] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Control -'), -1)),
                                                              _createElementVNode("p", _hoisted_342, _toDisplayString(work.additionalInfo.controlTitle), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('kpiName') && work.additionalInfo.kpiName && !work.additionalInfo.resultFindingsSync && !_ctx.hasFindingRelatedToChange(work.additionalInfo))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_343, [
                                                              _cache[255] || (_cache[255] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('KPI -'), -1)),
                                                              _createElementVNode("p", _hoisted_344, _toDisplayString(work.additionalInfo.kpiName), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (work.additionalInfo.resultFindingsSync)
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                                              (_ctx.getFindingResultMoveSummary(work.additionalInfo))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_345, [
                                                                    _cache[256] || (_cache[256] = _createElementVNode("p", { class: "font-semibold text-xs shrink-0" }, _toDisplayString('Finding linked to -'), -1)),
                                                                    _createElementVNode("p", _hoisted_346, _toDisplayString(_ctx.getFindingResultMoveSummary(work.additionalInfo)), 1)
                                                                  ]))
                                                                : (work.additionalInfo.resultFindingsSync.removedFromResult)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_347, [
                                                                      _cache[257] || (_cache[257] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Finding linked to -'), -1)),
                                                                      _createElementVNode("p", _hoisted_348, _toDisplayString(work.additionalInfo.resultFindingsSync.removedFromLabel || 'N/A'), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                            ], 64))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('riskTitle') && work.additionalInfo.riskTitle)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_349, [
                                                              _cache[258] || (_cache[258] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Risk -'), -1)),
                                                              _createElementVNode("p", _hoisted_350, _toDisplayString(work.additionalInfo.riskTitle), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.addedAttachments || []), (file) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex mt-2",
                                                            key: 'added-' + file
                                                          }, [
                                                            _cache[259] || (_cache[259] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Attached -'), -1)),
                                                            _createElementVNode("p", _hoisted_351, _toDisplayString(file), 1)
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.removedAttachments || []), (file) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex mt-2",
                                                            key: 'removed-' + file
                                                          }, [
                                                            _cache[260] || (_cache[260] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Removed the attachment -'), -1)),
                                                            _createElementVNode("p", _hoisted_352, _toDisplayString(file), 1)
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.changes || []), (change) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex items-center mt-2",
                                                            key: change.field
                                                          }, [
                                                            _createElementVNode("p", _hoisted_353, _toDisplayString(change.field), 1),
                                                            (change.field === 'Risk Severity' || change.field === 'Finding Severity')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", (change.field === 'Finding Severity' || Number(work.additionalInfo.resultfor) === 1) ? _ctx.reviewScaleChipBg(_ctx.controlRiskSeverityLabelOptions, change.previous) : _ctx.colorRiskBg(change.previous)])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["truncate whitespace-nowrap", (change.field === 'Finding Severity' || Number(work.additionalInfo.resultfor) === 1) ? _ctx.reviewScaleChipText(_ctx.controlRiskSeverityLabelOptions, change.previous) : _ctx.colorRiskText(change.previous)])
                                                                    }, _toDisplayString((change.field === 'Finding Severity' || Number(work.additionalInfo.resultfor) === 1) ? _ctx.getReviewScaleLabel(_ctx.controlRiskSeverityLabelOptions, change.previous) : _ctx.getSeverityLabel(change.previous)), 3)
                                                                  ], 2),
                                                                  _cache[261] || (_cache[261] = _createElementVNode("div", { class: "mx-2 flex items-center shrink-0" }, [
                                                                    _createElementVNode("img", {
                                                                      src: _imports_16,
                                                                      class: "shrink-0"
                                                                    })
                                                                  ], -1)),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", (change.field === 'Finding Severity' || Number(work.additionalInfo.resultfor) === 1) ? _ctx.reviewScaleChipBg(_ctx.controlRiskSeverityLabelOptions, change.updated) : _ctx.colorRiskBg(change.updated)])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["truncate whitespace-nowrap", (change.field === 'Finding Severity' || Number(work.additionalInfo.resultfor) === 1) ? _ctx.reviewScaleChipText(_ctx.controlRiskSeverityLabelOptions, change.updated) : _ctx.colorRiskText(change.updated)])
                                                                    }, _toDisplayString((change.field === 'Finding Severity' || Number(work.additionalInfo.resultfor) === 1) ? _ctx.getReviewScaleLabel(_ctx.controlRiskSeverityLabelOptions, change.updated) : _ctx.getSeverityLabel(change.updated)), 3)
                                                                  ], 2)
                                                                ], 64))
                                                              : (change.field === 'Health' || change.field === 'Operating Effectiveness')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", _ctx.reviewScaleChipBg(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.previous)]),
                                                                      title: _ctx.getReviewScaleLabel(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.previous)
                                                                    }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.previous)])
                                                                      }, _toDisplayString(_ctx.getReviewScaleLabel(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.previous)), 3)
                                                                    ], 10, _hoisted_354),
                                                                    _cache[262] || (_cache[262] = _createElementVNode("div", { class: "mx-2 flex items-center shrink-0" }, [
                                                                      _createElementVNode("img", {
                                                                        src: _imports_16,
                                                                        class: "shrink-0"
                                                                      })
                                                                    ], -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", _ctx.reviewScaleChipBg(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.updated)]),
                                                                      title: _ctx.getReviewScaleLabel(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.updated)
                                                                    }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["truncate whitespace-nowrap", _ctx.reviewScaleChipText(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.updated)])
                                                                      }, _toDisplayString(_ctx.getReviewScaleLabel(change.field === 'Health' ? _ctx.healthLabelOptions : _ctx.operatingEffectivenessLabelOptions, change.updated)), 3)
                                                                    ], 10, _hoisted_355)
                                                                  ], 64))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                    _createElementVNode("p", _hoisted_356, _toDisplayString(_ctx.formatResultHistoryValue(change.field, change.previous)), 1),
                                                                    _cache[263] || (_cache[263] = _createElementVNode("div", { class: "mx-2 flex items-center shrink-0" }, [
                                                                      _createElementVNode("img", {
                                                                        src: _imports_16,
                                                                        class: "shrink-0"
                                                                      })
                                                                    ], -1)),
                                                                    _createElementVNode("p", _hoisted_357, _toDisplayString(_ctx.formatResultHistoryValue(change.field, change.updated)), 1)
                                                                  ], 64))
                                                          ]))
                                                        }), 128)),
                                                        (Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_358, [
                                                              _cache[264] || (_cache[264] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_359, _toDisplayString(work.additionalInfo.evidence), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (work.additionalInfo.removed)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_360, [
                                                              _cache[265] || (_cache[265] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Deleted the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_361, _toDisplayString(work.additionalInfo.evidence), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceTitles'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_362, [
                                                              _cache[266] || (_cache[266] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Linked the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_363, _toDisplayString(work.additionalInfo.linkedEvidenceTitles), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceDates'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_364, [
                                                              _cache[267] || (_cache[267] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Linked Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_365, _toDisplayString(work.additionalInfo.linkedEvidenceDates), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('evidenceDate'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_366, [
                                                              _cache[268] || (_cache[268] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_367, _toDisplayString(_ctx.formatDate(work.additionalInfo.evidenceDate)||'N/A'), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('assignee'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_368, [
                                                              _cache[269] || (_cache[269] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Assigned the task to -'), -1)),
                                                              _createElementVNode("p", _hoisted_369, _toDisplayString(work.additionalInfo.name), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_370, [
                                                              _cache[271] || (_cache[271] = _createElementVNode("div", null, [
                                                                _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Updated The Status :'))
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_371, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorComplianceBg(work.additionalInfo.previousStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorComplianceText(work.additionalInfo.previousStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                ], 2),
                                                                _cache[270] || (_cache[270] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                  _createElementVNode("img", { src: _imports_16 })
                                                                ], -1)),
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorComplianceBg(work.additionalInfo.updatedStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorComplianceText(work.additionalInfo.updatedStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                ], 2)
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_372, [
              _createElementVNode("div", _hoisted_373, [
                _cache[287] || (_cache[287] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                  _createElementVNode("h1", null, "Task Details")
                ], -1)),
                (_ctx.tabDataLoading == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_374, [
                      _createElementVNode("div", _hoisted_375, [
                        _createVNode(_component_dots_loader)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_376, [
                      _createElementVNode("div", null, [
                        _cache[273] || (_cache[273] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                        (_ctx.TaskDetailsDropDown.taskStatus == 10418)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_377, _cache[272] || (_cache[272] = [
                              _createElementVNode("div", { class: "bg-error textColorWhite" }, _toDisplayString('Terminated'), -1)
                            ])))
                          : (_openBlock(), _createElementBlock("div", _hoisted_378, [
                              (_openBlock(), _createBlock(_component_Select, {
                                modelValue: _ctx.taskStatusModel,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.taskStatusModel) = $event)),
                                options: _ctx.crTaskStatuses,
                                appendTo: "body",
                                optionLabel: "label",
                                optionValue: "id",
                                class: _normalizeClass(["w-full statusBorder mt-2", _ctx.changeBackground()]),
                                key: 'cr-status-' + _ctx.statusSelectKey,
                                disabled: _ctx.TaskDetailsDropDown.taskStatus === 10403 || !_ctx.isAddDisabled(10302),
                                optionDisabled: (option) =>
                                        option.id === 10401 && _ctx.TaskDetailsDropDown.taskStatus !== 10401
                              }, null, 8, ["modelValue", "options", "class", "disabled", "optionDisabled"]))
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_379, [
                        _cache[274] || (_cache[274] = _createElementVNode("label", { class: "controllabel" }, "Reviewer", -1)),
                        _createElementVNode("div", null, [
                          _createVNode(_component_AutoComplete, {
                            modelValue: _ctx.presentTaskObject.reviewer,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.presentTaskObject.reviewer) = $event)),
                            suggestions: _ctx.TeamOwnerOptions,
                            onComplete: _ctx.asyncFind1,
                            onItemSelect: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateTaskForTeamLeader(_ctx.presentTaskObject.reviewer))),
                            optionLabel: "label",
                            optionValue: "value",
                            forceSelection: true,
                            placeholder: "Reviewer",
                            appendTo: "body",
                            disabled: _ctx.TaskDetailsDropDown.taskStatus==10403 || !_ctx.isAddDisabled(10302),
                            class: "p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect"
                          }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_380, [
                        _cache[275] || (_cache[275] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                        _cache[276] || (_cache[276] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.dueDate != undefined || _ctx.presentTaskObject.dueDate != null)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: _normalizeClass(["mt-2 text-sm rounded w-24", _ctx.shouldStyleDueDate(_ctx.presentTaskObject) ? _ctx.colorForDueDate(_ctx.presentTaskObject.dueDate) : '']),
                              "\"": ""
                            }, _toDisplayString(_ctx.formatDate(_ctx.presentTaskObject.dueDate)), 3))
                          : (_openBlock(), _createElementBlock("p", _hoisted_381, "N/A"))
                      ]),
                      (((_ctx.presentTaskObject.appId && _ctx.presentTaskObject.appId==10003)|| _ctx.presentTaskObject.treatmentType!=undefined))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_382, [
                            _cache[277] || (_cache[277] = _createElementVNode("label", { class: "controllabel mb-2" }, "Treatment Type", -1)),
                            _cache[278] || (_cache[278] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.treatmentTypeBgColor(_ctx.presentTaskObject.treatmentType)])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-xs", _ctx.treatmentTypeTextColor(_ctx.presentTaskObject.treatmentType)])
                              }, _toDisplayString(_ctx.presentTask(_ctx.presentTaskObject.treatmentType)||'N/A'), 3)
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_383, [
                        _cache[279] || (_cache[279] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                        _cache[280] || (_cache[280] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.departments != undefined || _ctx.presentTaskObject.departments != null)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_384, _toDisplayString(_ctx.getTeamName(_ctx.presentTaskObject.departments)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_385, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_386, [
                        _cache[281] || (_cache[281] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                        _cache[282] || (_cache[282] = _createElementVNode("br", null, null, -1)),
                        (Object.keys(_ctx.presentTaskObject).includes('location') && (_ctx.presentTaskObject.location!=undefined || _ctx.presentTaskObject.location!=null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_387, _toDisplayString(_ctx.presentTaskObject.location), 1))
                          : (Object.keys(_ctx.presentTaskObject).includes('location') && !Object.keys(_ctx.presentTaskObject).includes('entity') && _ctx.presentTaskObject.location != '' && _ctx.presentTaskObject.location != null && _ctx.presentTaskObject.location != undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_388, _toDisplayString(_ctx.presentTaskObject.location), 1))
                            : (Object.keys(_ctx.presentTaskObject).includes('entity') && _ctx.presentTaskObject.entity != '' && _ctx.presentTaskObject.entity != null && _ctx.presentTaskObject.entity != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_389, _toDisplayString(_ctx.getEntity(_ctx.presentTaskObject.entity)), 1))
                              : (Object.keys(_ctx.presentTaskObject).includes('location') && (_ctx.presentTaskObject.location=='' || _ctx.presentTaskObject.location==null)&& _ctx.presentTaskObject.department!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_390, _toDisplayString(_ctx.getLocationNameForSystem(_ctx.presentTaskObject.department)), 1))
                                : ((_ctx.presentTaskObject.entity ==""||_ctx.presentTaskObject.entity !=null) && _ctx.presentTaskObject.location!=null )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_391, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (val) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: val._id
                                        }, [
                                          (val._id==_ctx.presentTaskObject.department && val.entityType==20301)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_392, _toDisplayString('Global')))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_393, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_394, [
                        _cache[283] || (_cache[283] = _createElementVNode("label", { class: "controllabel mb-2" }, "Tier", -1)),
                        _cache[284] || (_cache[284] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", null, _toDisplayString(_ctx.getTargetDetails(_ctx.presentTaskObject).tier), 1)
                      ]),
                      _createElementVNode("div", _hoisted_395, [
                        _cache[285] || (_cache[285] = _createElementVNode("label", { class: "controllabel mb-2" }, "Scope", -1)),
                        _cache[286] || (_cache[286] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.tierTitle != '' && _ctx.presentTaskObject.tierTitle != null && _ctx.presentTaskObject.tierTitle != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_396, _toDisplayString(_ctx.presentTaskObject.tierTitle), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_397, "N/A"))
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_398, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.isEditingFinding ? 'Edit Finding' : 'Findings'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _cache[288] || (_cache[288] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_399, [
              _createElementVNode("div", _hoisted_400, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_401, [
                    _createElementVNode("div", _hoisted_402, [
                      _createElementVNode("div", _hoisted_403, [
                        _createElementVNode("div", _hoisted_404, [
                          _createElementVNode("div", _hoisted_405, [
                            _cache[289] || (_cache[289] = _createElementVNode("label", { class: "controllabel" }, "Finding Id", -1)),
                            _createElementVNode("div", _hoisted_406, _toDisplayString(_ctx.findingsObject.findingId?.toUpperCase()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_407, [
                            _cache[290] || (_cache[290] = _createElementVNode("label", { class: "controllabel" }, "Evidence", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.findingsObject.findingEvidence,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.findingsObject.findingEvidence) = $event)),
                              forceSelection: "",
                              suggestions: _ctx.filteredOptions,
                              onComplete: _ctx.asyncFind,
                              placeholder: 'Evidences',
                              class: _normalizeClass(["p-inputtext-sm systemsstyling custom-multiselect userSelect mt-2 findings-evidence-autocomplete",  {'p-invalid': _ctx.v$.findingsObject.findingEvidence.$error }])
                            }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                            (_ctx.v$.findingsObject.findingEvidence.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_408, [
                                  (_ctx.v$.findingsObject.findingEvidence.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_409, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_410, [
                        _createElementVNode("div", _hoisted_411, [
                          _cache[291] || (_cache[291] = _createElementVNode("label", { class: "controllabel" }, "Related To", -1)),
                          _createVNode(_component_Select, {
                            modelValue: _ctx.findingsObject.findingRelatedTo,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.findingsObject.findingRelatedTo) = $event)),
                            options: _ctx.findingRelatedToOptions,
                            optionLabel: "label",
                            optionValue: "value",
                            placeholder: "Please select one",
                            appendTo: "self",
                            class: _normalizeClass(["w-full mt-2 findings-select", { 'is-invalid': _ctx.v$.findingsObject.findingRelatedTo.$error }]),
                            disabled: _ctx.isRiskRelatedCrTask,
                            onChange: _ctx.onFindingRelatedToChange
                          }, null, 8, ["modelValue", "options", "class", "disabled", "onChange"]),
                          (_ctx.v$.findingsObject.findingRelatedTo.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_412, [
                                (_ctx.v$.findingsObject.findingRelatedTo.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_413, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (Number(_ctx.findingsObject.findingRelatedTo) === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_414, [
                              _cache[292] || (_cache[292] = _createElementVNode("label", { class: "controllabel" }, "Control", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.findingsObject.control_id,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.findingsObject.control_id) = $event)),
                                options: _ctx.taskMappedControlOptions,
                                optionLabel: "label",
                                optionValue: "_id",
                                placeholder: "No control mapped to this task",
                                appendTo: "self",
                                class: _normalizeClass(["w-full mt-2 findings-select", { 'is-invalid': _ctx.v$.findingsObject.control_id.$error }]),
                                disabled: _ctx.taskMappedControlOptions.length <= 1
                              }, null, 8, ["modelValue", "options", "class", "disabled"]),
                              (_ctx.v$.findingsObject.control_id.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_415, [
                                    (_ctx.v$.findingsObject.control_id.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_416, "No control mapped to this task"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (Number(_ctx.findingsObject.findingRelatedTo) === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_417, [
                                _cache[293] || (_cache[293] = _createElementVNode("label", { class: "controllabel" }, "KPI", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.findingsObject.kpi_id,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.findingsObject.kpi_id) = $event)),
                                  options: _ctx.presentTaskObject.kpis || [],
                                  optionLabel: "description",
                                  optionValue: "_id",
                                  placeholder: "Please select one",
                                  appendTo: "self",
                                  class: _normalizeClass(["w-full mt-2 kpi-title-select findings-select", { 'is-invalid': _ctx.v$.findingsObject.kpi_id.$error }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.findingsObject.kpi_id.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_418, [
                                      (_ctx.v$.findingsObject.kpi_id.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_419, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (Number(_ctx.findingsObject.findingRelatedTo) === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_420, [
                                  _cache[294] || (_cache[294] = _createElementVNode("label", { class: "controllabel" }, "Risk", -1)),
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: "inputboxstyling mt-2 w-full risk-title-input disiableState",
                                    value: _ctx.getRiskFindingTitle(),
                                    title: _ctx.getRiskFindingTitle(),
                                    disabled: ""
                                  }, null, 8, _hoisted_421)
                                ]))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_422, [
                        _createElementVNode("div", _hoisted_423, [
                          _cache[295] || (_cache[295] = _createElementVNode("label", { class: "controllabel" }, "Finding Severity", -1)),
                          _createVNode(_component_Select, {
                            modelValue: _ctx.findingsObject.findingSeverity,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.findingsObject.findingSeverity) = $event)),
                            options: _ctx.controlRiskSeverityLabelOptions,
                            optionLabel: "key",
                            optionValue: "value",
                            placeholder: "Please select one",
                            appendTo: "self",
                            class: _normalizeClass(["w-full mt-2 findings-select", { 'is-invalid': _ctx.v$.findingsObject.findingSeverity.$error }])
                          }, null, 8, ["modelValue", "options", "class"]),
                          (_ctx.v$.findingsObject.findingSeverity.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_424, [
                                (_ctx.v$.findingsObject.findingSeverity.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_425, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_426, [
                        _cache[296] || (_cache[296] = _createElementVNode("label", { class: "controllabel" }, "Finding", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.findingsObject.finding) = $event)),
                          class: _normalizeClass(["inputboxstyling mt-2 resize-none", { 'is-invalid': _ctx.v$.findingsObject.finding.$error }]),
                          placeholder: "Finding",
                          rows: "3",
                          onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.v$.findingsObject.finding.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.findingsObject.finding,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.findingsObject.finding.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_427, [
                              (_ctx.v$.findingsObject.finding.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_428, "Required"))
                                : (_ctx.v$.findingsObject.finding.required && _ctx.v$.findingsObject.finding.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_429, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[297] || (_cache[297] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_430, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.findingsObject) !== JSON.stringify(_ctx.findingsObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCancelbtn()))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", JSON.stringify(_ctx.findingsObject) !== JSON.stringify(_ctx.findingsObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    disabled: _ctx.clickOnButtonForFinding,
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.addFindingButton()))
                  }, "Save", 10, _hoisted_431)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUpForResult)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.showPopUpForResult
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_432, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.isEditingResult ? 'Edit Result' : 'Result'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onCancelButtonAddPopUpForResult()))
              }, _cache[298] || (_cache[298] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_433, [
              _createElementVNode("div", _hoisted_434, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_435, [
                    _createElementVNode("div", _hoisted_436, [
                      _createElementVNode("div", _hoisted_437, [
                        _createElementVNode("div", _hoisted_438, [
                          _createElementVNode("div", _hoisted_439, [
                            _cache[299] || (_cache[299] = _createElementVNode("label", { class: "controllabel" }, "Population", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.handlePopulationDecimalValue && _ctx.handlePopulationDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.resultObject.totalPopulation) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation }]),
                              placeholder: "Population",
                              onKeyup: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isTotalPopulationValid()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.resultObject.totalPopulation,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            ((_ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_440, [
                                  (_ctx.v$.resultObject.totalPopulation.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_441, "Required"))
                                    : (!_ctx.resultOfPopulation && !_ctx.v$.resultObject.totalPopulation.required.$invalid )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_442, "Population must be greater than or equal to Compliant"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_443, [
                            _cache[300] || (_cache[300] = _createElementVNode("label", { class: "controllabel" }, "Compliant", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.handleComplaintDecimalValue && _ctx.handleComplaintDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.resultObject.actualOutput) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.actualOutput.$error, 'disiableState': !_ctx.isCompliantInputEnabled }]),
                              placeholder: "Compliant",
                              disabled: !_ctx.isCompliantInputEnabled
                            }, null, 42, _hoisted_444), [
                              [
                                _vModelText,
                                _ctx.resultObject.actualOutput,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.resultObject.actualOutput.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_445, [
                                  (_ctx.v$.resultObject.actualOutput.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_446, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_447, [
                        _createElementVNode("div", _hoisted_448, [
                          _createElementVNode("div", _hoisted_449, [
                            _cache[301] || (_cache[301] = _createElementVNode("label", { class: "controllabel" }, "Risk Severity", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.resultObject.riskSeverity,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.resultObject.riskSeverity) = $event)),
                              options: _ctx.controlRiskSeverityLabelOptions,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              appendTo: "body",
                              class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.resultObject.riskSeverity.$error }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.resultObject.riskSeverity.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_450, [
                                  (_ctx.v$.resultObject.riskSeverity.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_451, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_452, [
                            _cache[302] || (_cache[302] = _createElementVNode("label", { class: "controllabel" }, "Health", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.resultObject.reviewHealth,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.resultObject.reviewHealth) = $event)),
                              options: _ctx.healthLabelOptions,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              appendTo: "body",
                              class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.resultObject.reviewHealth.$error }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.resultObject.reviewHealth.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_453, [
                                  (_ctx.v$.resultObject.reviewHealth.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_454, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_455, [
                        _createElementVNode("div", _hoisted_456, [
                          _createElementVNode("div", _hoisted_457, [
                            _cache[303] || (_cache[303] = _createElementVNode("label", { class: "controllabel" }, "Operating Effectiveness", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.resultObject.operatingEffectiveness,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.resultObject.operatingEffectiveness) = $event)),
                              options: _ctx.operatingEffectivenessLabelOptions,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              appendTo: "body",
                              class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.resultObject.operatingEffectiveness.$error }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.resultObject.operatingEffectiveness.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_458, [
                                  (_ctx.v$.resultObject.operatingEffectiveness.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_459, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_460, [
                        _cache[304] || (_cache[304] = _createElementVNode("label", { class: "controllabel" }, "Conclusion", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.resultObject.comments) = $event)),
                          class: _normalizeClass(["inputboxstyling resize-none mt-2", { 'is-invalid': _ctx.v$.resultObject.comments.$error }]),
                          placeholder: "Conclusion",
                          rows: "3",
                          onInput: _cache[44] || (_cache[44] = ($event: any) => (_ctx.v$.resultObject.comments.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.resultObject.comments,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.resultObject.comments.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_461, [
                              (_ctx.v$.resultObject.comments.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_462, "Required"))
                                : (_ctx.v$.resultObject.comments.required && _ctx.v$.resultObject.comments.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_463, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.resultPopupFindings.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_464, [
                            _cache[305] || (_cache[305] = _createElementVNode("label", { class: "controllabel" }, "Findings", -1)),
                            _createElementVNode("div", _hoisted_465, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPopupFindings, (finding, fIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: finding._id || finding.findingId || fIndex,
                                  class: "w-auto min-h-6 mr-1 px-2.5 py-1 rounded-sm flex items-center text-sm font-normal border border-solid border-lightgrey result-finding-chip"
                                }, _toDisplayString(finding.finding), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[306] || (_cache[306] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_466, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onCancelbtnForResult()))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    disabled: _ctx.clickOnButtonForResult,
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.addResultButtonForTask(_ctx.resultObject)))
                  }, "Save", 10, _hoisted_467)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUpForKpi)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          popUp: _ctx.showPopUpForKpi
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_468, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.isEditingKpi ? 'Edit KPI Result' : 'Result'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onCancelButtonAddPopUpForKpi()))
              }, _cache[307] || (_cache[307] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_469, [
              _createElementVNode("div", _hoisted_470, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_471, [
                    _createElementVNode("div", _hoisted_472, [
                      _createElementVNode("div", _hoisted_473, [
                        _createElementVNode("div", _hoisted_474, [
                          _createElementVNode("div", _hoisted_475, [
                            (_ctx.presentTaskObject.kpis)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_476, [
                                  _cache[308] || (_cache[308] = _createElementVNode("label", { class: "controllabel" }, "KPI Title", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.resultObject.controlorKpi,
                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.resultObject.controlorKpi) = $event)),
                                    options: _ctx.kpisArray,
                                    onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.getKpis())),
                                    optionLabel: "description",
                                    optionValue: "_id",
                                    placeholder: "Please select one",
                                    appendTo: "self",
                                    class: _normalizeClass(["w-full mt-2 kpi-title-select", { 'is-invalid': _ctx.v$.resultObject.controlorKpi.$error }]),
                                    onChange: _ctx.onKpiChange,
                                    disabled: _ctx.isEditingKpi
                                  }, null, 8, ["modelValue", "options", "class", "onChange", "disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.v$.resultObject.controlorKpi.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_477, [
                                  (_ctx.v$.resultObject.controlorKpi.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_478, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_479, [
                        _createElementVNode("div", _hoisted_480, [
                          _createElementVNode("div", _hoisted_481, [
                            _cache[309] || (_cache[309] = _createElementVNode("label", { class: "controllabel" }, "KPI ID", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.resultObject.kpiId) = $event)),
                              placeholder: "KPI ID",
                              class: "inputboxstyling mt-2 disiableState",
                              disabled: ""
                            }, null, 512), [
                              [_vModelText, _ctx.resultObject.kpiId]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_482, [
                            _cache[310] || (_cache[310] = _createElementVNode("label", { class: "controllabel" }, "Target Type", -1)),
                            _createElementVNode("input", {
                              type: "text",
                              value: _ctx.getKpiTargetTypeLabel(_ctx.resultObject.targetType),
                              placeholder: "Target Type",
                              class: "inputboxstyling mt-2 disiableState",
                              disabled: ""
                            }, null, 8, _hoisted_483)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_484, [
                        _createElementVNode("div", _hoisted_485, [
                          _createElementVNode("div", _hoisted_486, [
                            _cache[311] || (_cache[311] = _createElementVNode("label", { class: "controllabel" }, "Condition", -1)),
                            _createElementVNode("input", {
                              type: "text",
                              value: _ctx.resultObject.controlorKpi ? _ctx.getKpiConditionLabel(_ctx.resultObject.kpiCondition) : '',
                              placeholder: "Condition",
                              class: "inputboxstyling mt-2 disiableState",
                              disabled: ""
                            }, null, 8, _hoisted_487)
                          ]),
                          _createElementVNode("div", _hoisted_488, [
                            _createElementVNode("label", _hoisted_489, _toDisplayString(_ctx.resultObject.targetType === 'number' ? 'Target' : 'Target (%)'), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.resultObject.kpiTarget) = $event)),
                              placeholder: _ctx.resultObject.targetType === 'number' ? 'Target' : 'Target (%)',
                              class: "inputboxstyling mt-2 disiableState",
                              disabled: ""
                            }, null, 8, _hoisted_490), [
                              [_vModelText, _ctx.resultObject.kpiTarget]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_491, [
                        _createElementVNode("div", _hoisted_492, [
                          _createElementVNode("div", _hoisted_493, [
                            _cache[312] || (_cache[312] = _createElementVNode("label", { class: "controllabel" }, "Population", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.handlePopulationDecimalValue && _ctx.handlePopulationDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.resultObject.totalPopulation) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation }]),
                              placeholder: "Population",
                              onKeyup: _cache[54] || (_cache[54] = ($event: any) => (_ctx.isTotalPopulationValid()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.resultObject.totalPopulation,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_494, [
                                  (_ctx.v$.resultObject.totalPopulation.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_495, "Required"))
                                    : (!_ctx.resultOfPopulation && !_ctx.v$.resultObject.totalPopulation.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_496, "Population must be greater than or equal to Compliant"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_497, [
                            _cache[313] || (_cache[313] = _createElementVNode("label", { class: "controllabel" }, "Compliant", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.handleComplaintDecimalValue && _ctx.handleComplaintDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.resultObject.actualOutput) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", {
                            'is-invalid': _ctx.v$.resultObject.actualOutput.$error,
                            'disiableState': _ctx.resultObject.targetType !== 'percentage' || !_ctx.isCompliantInputEnabled,
                          }]),
                              placeholder: "Compliant",
                              disabled: _ctx.resultObject.targetType !== 'percentage' || !_ctx.isCompliantInputEnabled
                            }, null, 42, _hoisted_498), [
                              [
                                _vModelText,
                                _ctx.resultObject.actualOutput,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.resultObject.actualOutput.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_499, [
                                  (_ctx.v$.resultObject.actualOutput.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_500, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_501, [
                        _createElementVNode("div", _hoisted_502, [
                          _createElementVNode("div", _hoisted_503, [
                            _cache[314] || (_cache[314] = _createElementVNode("label", { class: "controllabel" }, "Risk Severity", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.resultObject.riskSeverity,
                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.resultObject.riskSeverity) = $event)),
                              options: _ctx.dbSeverity,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              appendTo: "body",
                              class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.resultObject.riskSeverity.$error }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.resultObject.riskSeverity.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_504, [
                                  (_ctx.v$.resultObject.riskSeverity.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_505, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_506, [
                        _cache[315] || (_cache[315] = _createElementVNode("label", { class: "controllabel" }, "Comments", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.resultObject.comments) = $event)),
                          class: _normalizeClass(["inputboxstyling resize-none mt-2", { 'is-invalid': _ctx.v$.resultObject.comments.$error }]),
                          placeholder: "Comments",
                          rows: "3",
                          onInput: _cache[59] || (_cache[59] = ($event: any) => (_ctx.v$.resultObject.comments.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.resultObject.comments,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.resultObject.comments.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_507, [
                              (_ctx.v$.resultObject.comments.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_508, "Required"))
                                : (_ctx.v$.resultObject.comments.required && _ctx.v$.resultObject.comments.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_509, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.resultPopupFindings.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_510, [
                            _cache[316] || (_cache[316] = _createElementVNode("label", { class: "controllabel" }, "Findings", -1)),
                            _createElementVNode("div", _hoisted_511, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPopupFindings, (finding, fIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: finding._id || finding.findingId || fIndex,
                                  class: "w-auto min-h-6 mr-1 px-2.5 py-1 rounded-sm flex items-center text-sm font-normal border border-solid border-lightgrey result-finding-chip"
                                }, _toDisplayString(finding.finding), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[317] || (_cache[317] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_512, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.onCancelbtnForResult()))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    disabled: _ctx.clickOnButtonForResult,
                    onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.addResultButtonForTaskKpi(_ctx.resultObject)))
                  }, "Save", 10, _hoisted_513)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 5,
          popUp: _ctx.importpopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_514, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.onCancelIcon()))
              }, _cache[318] || (_cache[318] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_515, [
              _createElementVNode("div", _hoisted_516, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_517, [
                    _createElementVNode("div", _hoisted_518, [
                      _createElementVNode("div", _hoisted_519, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_520, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Title' : 'File Name'), 1),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                            type: "text",
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.inputFileName) = $event)),
                            placeholder: _ctx.evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename',
                            onInput: _cache[64] || (_cache[64] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                          }, null, 42, _hoisted_521), [
                            [
                              _vModelText,
                              _ctx.inputFileName,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.inputFileName.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_522, [
                                (_ctx.v$.inputFileName.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_523, "Required"))
                                  : (_ctx.v$.inputFileName.required && _ctx.v$.inputFileName.restrictCharacters50.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_524, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.evidenceAttachMode === 'file')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_525, [
                              _cache[321] || (_cache[321] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "fileInput",
                                class: "hidden",
                                id: "upload",
                                onChange: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                              }, null, 544),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-auto rounded-sm mt-2 p-8 flex flex-col items-center justify-center text-center transition border-2 border-dashed border-lightgrey bg-whitegrey", {
                    'is-invalid': _ctx.v$.fileToUpload.$error || _ctx.pdfValidation,
                    'border-primary': _ctx.isDragOver
                  }]),
                                onDragenter: _cache[67] || (_cache[67] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                onDragover: _cache[68] || (_cache[68] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                onDragleave: _cache[69] || (_cache[69] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"])),
                                onDrop: _cache[70] || (_cache[70] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDrop && _ctx.onFileDrop(...args)), ["prevent"]))
                              }, [
                                _cache[320] || (_cache[320] = _createElementVNode("img", {
                                  src: _imports_18,
                                  class: "h-10 w-10 mb-3",
                                  alt: "Upload file"
                                }, null, -1)),
                                (_ctx.fileName === '')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_526, " Drag and drop your file here "))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_527, _toDisplayString(_ctx.fileName), 1)),
                                _createElementVNode("div", _hoisted_528, [
                                  _cache[319] || (_cache[319] = _createElementVNode("label", {
                                    for: "upload",
                                    class: "cursor-pointer"
                                  }, [
                                    _createElementVNode("span", { class: "btnprimary text-xs gap-1" }, [
                                      _createElementVNode("img", {
                                        src: _imports_19,
                                        class: "h-4 w-4",
                                        alt: ""
                                      }),
                                      _createTextVNode(" Browse ")
                                    ])
                                  ], -1)),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["filterButton text-xs gap-1", _ctx.fileName === '' ? 'filterButtondisabled pointer-events-none' : '']),
                                    disabled: _ctx.fileName === '',
                                    onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedFile && _ctx.clearSelectedFile(...args)))
                                  }, " Cancel ", 10, _hoisted_529)
                                ])
                              ], 34),
                              _createElementVNode("div", _hoisted_530, [
                                (_ctx.v$.fileToUpload.$invalid && !_ctx.pdfValidation && (_ctx.v$.fileToUpload.$error || _ctx.pdfValidation))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_531, " File upload is required "))
                                  : _createCommentVNode("", true),
                                (_ctx.pdfValidation && !_ctx.v$.fileToUpload.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_532, " This File Format is not Supported "))
                                  : _createCommentVNode("", true)
                              ]),
                              _cache[322] || (_cache[322] = _createElementVNode("div", { class: "mt-2 flex flex-col items-center" }, [
                                _createElementVNode("p", { class: "text-xs text-placeholder" }, " Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4 "),
                                _createElementVNode("p", { class: "text-xs text-placeholder mt-1" }, " Maximum File Size: 50 MB ")
                              ], -1))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.evidenceAttachMode === 'url')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_533, [
                              _cache[323] || (_cache[323] = _createElementVNode("label", { class: "controllabel" }, "URL", -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.evidenceUrl.$error }]),
                                type: "url",
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.evidenceUrl) = $event)),
                                placeholder: "URL",
                                onInput: _cache[72] || (_cache[72] = ($event: any) => (_ctx.v$.evidenceUrl.$touch()))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.evidenceUrl,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.evidenceUrl.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_534, [
                                    (_ctx.v$.evidenceUrl.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_535, "Required"))
                                      : (_ctx.v$.evidenceUrl.httpUrl.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_536, "URL must use http or https"))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_537, [
                          _cache[324] || (_cache[324] = _createElementVNode("label", { class: "controllabel" }, "Evidence Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.evidenceDate) = $event)),
                            type: "date",
                            class: _normalizeClass(["mt-2 w-full", {
                      'inputboxstylingForSelectAtPopup': _ctx.evidenceDate == '',
                      'stylingForInputboxstylingForSelectAtPopup': _ctx.evidenceDate != '',
                      'is-invalid':_ctx.v$.evidenceDate.$error
                      }]),
                            onFocus: _cache[74] || (_cache[74] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            style: {"height":"28px"},
                            onkeydown: "return false",
                            placeholder: "Select Date",
                            max: _ctx.todayDate
                          }, null, 42, _hoisted_538), [
                            [_vModelText, _ctx.evidenceDate]
                          ]),
                          (_ctx.v$.evidenceDate.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_539, [
                                (_ctx.v$.evidenceDate.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_540, "Evidence date is required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[325] || (_cache[325] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_541, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary", _ctx.isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                    onClick: _cache[75] || (_cache[75] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                    disabled: _ctx.clickOnButton
                  }, "Save", 10, _hoisted_542)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showCompleteConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_543, [
            _createElementVNode("div", _hoisted_544, [
              _cache[326] || (_cache[326] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
                _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_20,
                    class: "h-6 w-6",
                    alt: ""
                  })
                ]),
                _createElementVNode("div", { class: "flex-1" }, [
                  _createElementVNode("h3", { class: "text-xl font-semibold text-darkblue" }, " Mark task as Completed? ")
                ])
              ], -1)),
              _cache[327] || (_cache[327] = _createElementVNode("p", { class: "text-sm text-gray-600 mt-2" }, " Control result, KPI result and Finding data will no longer be editable. ", -1)),
              _createElementVNode("div", _hoisted_545, [
                _createElementVNode("button", {
                  type: "button",
                  class: "cr-complete-btn-cancel",
                  onClick: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.cancelCompleteTask && _ctx.cancelCompleteTask(...args)))
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "button",
                  class: "cr-complete-btn-confirm",
                  onClick: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.confirmCompleteTask && _ctx.confirmCompleteTask(...args)))
                }, " Confirm ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showDeleteFindingConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_546, [
            _createElementVNode("div", _hoisted_547, [
              _cache[328] || (_cache[328] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
                _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_20,
                    class: "h-6 w-6",
                    alt: ""
                  })
                ]),
                _createElementVNode("div", { class: "flex-1" }, [
                  _createElementVNode("h3", { class: "text-xl font-semibold text-darkblue" }, " Delete finding? ")
                ])
              ], -1)),
              _createElementVNode("p", _hoisted_548, " Finding " + _toDisplayString(_ctx.findingPendingDelete?.findingId?.toUpperCase()) + " will be removed from this task. ", 1),
              _createElementVNode("div", _hoisted_549, [
                _createElementVNode("button", {
                  type: "button",
                  class: "cr-complete-btn-cancel",
                  onClick: _cache[78] || (_cache[78] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteFinding && _ctx.cancelDeleteFinding(...args)))
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "button",
                  class: "cr-complete-btn-confirm",
                  onClick: _cache[79] || (_cache[79] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteFinding && _ctx.confirmDeleteFinding(...args)))
                }, " Delete ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_ctx.showDeleteEvidenceConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_550, [
          _createElementVNode("div", {
            class: "evidence-delete-backdrop",
            onClick: _cache[80] || (_cache[80] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
          }),
          _createElementVNode("div", _hoisted_551, [
            _cache[329] || (_cache[329] = _createElementVNode("div", { class: "evidence-delete-dialog-title" }, [
              _createElementVNode("div", { class: "evidence-delete-warning" }, [
                _createElementVNode("img", {
                  src: _imports_20,
                  class: "evidence-delete-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Delete Evidence")
            ], -1)),
            _cache[330] || (_cache[330] = _createElementVNode("p", { class: "evidence-delete-dialog-message" }, "Are you sure you want to delete this evidence?", -1)),
            _createElementVNode("div", _hoisted_552, [
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-cancel",
                onClick: _cache[81] || (_cache[81] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-ok",
                onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteEvidence && _ctx.confirmDeleteEvidence(...args)))
              }, "OK")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.linkEvidencePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_553, [
          _createElementVNode("div", {
            class: "link-existing-backdrop",
            onClick: _cache[83] || (_cache[83] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
          }),
          _createElementVNode("div", _hoisted_554, [
            _cache[340] || (_cache[340] = _createElementVNode("div", { class: "link-existing-title" }, [
              _createElementVNode("span", {
                class: "link-existing-warning",
                "aria-hidden": "true"
              }, [
                _createElementVNode("img", {
                  src: _imports_20,
                  class: "link-existing-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Link Existing Evidence")
            ], -1)),
            _cache[341] || (_cache[341] = _createElementVNode("p", { class: "link-existing-message" }, "Select evidence from the past year listed below.", -1)),
            _createElementVNode("div", _hoisted_555, [
              _createElementVNode("div", _hoisted_556, [
                _createElementVNode("div", _hoisted_557, "EXISTING EVIDENCE (" + _toDisplayString(_ctx.filteredSortedExistingEvidences.length) + ")", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "filterButton flex",
                  onClick: _cache[84] || (_cache[84] = 
//@ts-ignore
(...args) => (_ctx.toggleExistingEvidenceFilters && _ctx.toggleExistingEvidenceFilters(...args)))
                }, _cache[331] || (_cache[331] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "filterIcon"
                  }, null, -1),
                  _createTextVNode(" Filters ")
                ]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["link-existing-table-wrap", { 'link-existing-table-wrap--empty': _ctx.filteredSortedExistingEvidences.length === 0 }])
              }, [
                _createElementVNode("table", _hoisted_558, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[336] || (_cache[336] = _createElementVNode("th", { class: "link-existing-col-check" }, null, -1)),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.sortExistingEvidence('filename')))
                      }, [
                        _createElementVNode("div", _hoisted_559, [
                          _cache[332] || (_cache[332] = _createElementVNode("div", { class: "table-header-label" }, "TITLE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'filename' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.sortExistingEvidence('sourceTaskId')))
                      }, [
                        _createElementVNode("div", _hoisted_560, [
                          _cache[333] || (_cache[333] = _createElementVNode("div", { class: "table-header-label" }, "TASK ID", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'sourceTaskId' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.sortExistingEvidence('evidenceType')))
                      }, [
                        _createElementVNode("div", _hoisted_561, [
                          _cache[334] || (_cache[334] = _createElementVNode("div", { class: "table-header-label" }, "TYPE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceType' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.sortExistingEvidence('evidenceDate')))
                      }, [
                        _createElementVNode("div", _hoisted_562, [
                          _cache[335] || (_cache[335] = _createElementVNode("div", { class: "table-header-label" }, "EVIDENCE DATE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceDate' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ])
                    ]),
                    (_ctx.showExistingEvidenceFilters)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_563, [
                          _cache[337] || (_cache[337] = _createElementVNode("td", { class: "link-existing-col-check" }, null, -1)),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.existingEvidenceFilters.filename) = $event)),
                              placeholder: "Search",
                              onClick: _cache[90] || (_cache[90] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.filename,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.existingEvidenceFilters.sourceTaskId) = $event)),
                              placeholder: "Search",
                              onClick: _cache[92] || (_cache[92] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.sourceTaskId,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.existingEvidenceFilters.evidenceType) = $event)),
                              placeholder: "Search",
                              onClick: _cache[94] || (_cache[94] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.evidenceType,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _cache[338] || (_cache[338] = _createElementVNode("td", null, null, -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.filteredSortedExistingEvidences.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_564, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedExistingEvidences, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.optionKey
                          }, [
                            _createElementVNode("td", _hoisted_565, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.isExistingEvidenceSelected(row),
                                onChange: ($event: any) => (_ctx.toggleExistingEvidence(row))
                              }, null, 40, _hoisted_566)
                            ]),
                            _createElementVNode("td", {
                              title: row.filename
                            }, _toDisplayString(row.filename), 9, _hoisted_567),
                            _createElementVNode("td", null, _toDisplayString(row.sourceTaskId), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.existingEvidenceTypeLabel(row)), 1),
                            _createElementVNode("td", null, _toDisplayString(row.evidenceDate ? _ctx.formatFileAttachedTime(row.evidenceDate) : 'N/A'), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_568, _cache[339] || (_cache[339] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            class: "link-existing-empty",
                            colspan: "5"
                          }, "No Records Found")
                        ], -1)
                      ])))
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_569, [
              _createElementVNode("button", {
                type: "button",
                class: "link-existing-cancel",
                onClick: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["link-existing-save", _ctx.selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : '']),
                onClick: _cache[96] || (_cache[96] = 
//@ts-ignore
(...args) => (_ctx.saveLinkedEvidence && _ctx.saveLinkedEvidence(...args)))
              }, "Save", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}